import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
};

export type AchInput = {
  account_number: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  routing_number: Scalars['String']['input'];
};

export type AddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  address_city: Scalars['String']['input'];
  address_country: Scalars['String']['input'];
  address_state: Scalars['String']['input'];
  address_zip: Scalars['String']['input'];
};

export type CalculateRentersCancelInput = {
  lastActiveDate: Scalars['String']['input'];
  policyNumber: Scalars['String']['input'];
};

export type CalculateRentersCancelResponse = {
  __typename?: 'CalculateRentersCancelResponse';
  coverageEndDate: Scalars['String']['output'];
  flatCancel: Scalars['Boolean']['output'];
  lastActiveDate: Scalars['String']['output'];
  monthsRefunded: Scalars['Int']['output'];
  paymentsRemaining: Scalars['Int']['output'];
  policyEndDate: Scalars['String']['output'];
  refundAmount: Scalars['Float']['output'];
};

export type CalculateRentersUpdateInput = {
  deductible: Scalars['Int']['input'];
  draftEffectiveDate: Scalars['String']['input'];
  earthquakeCoverage: Scalars['Int']['input'];
  insuredChanged: Scalars['Boolean']['input'];
  insuredCity: Scalars['String']['input'];
  insuredState: Scalars['String']['input'];
  insuredZip: Scalars['String']['input'];
  lastActiveDate: Scalars['String']['input'];
  liabilityCoverage: Scalars['Int']['input'];
  paymentInterval: Scalars['Int']['input'];
  policyNumber: Scalars['String']['input'];
  preferred: Scalars['Boolean']['input'];
  propertyCoverage: Scalars['Int']['input'];
  sprinklerCredit?: InputMaybe<SprinklerEnum>;
  startDate: Scalars['String']['input'];
};

export type CalculateRentersUpdateNextPolicy = {
  __typename?: 'CalculateRentersUpdateNextPolicy';
  amount_due: Scalars['Float']['output'];
  coverage_start_date?: Maybe<Scalars['String']['output']>;
  next_pay_date?: Maybe<Scalars['String']['output']>;
};

export enum CalculateRentersUpdateOperationEnum {
  CancelRewrite = 'cancel_rewrite',
  Modify = 'modify'
}

export type CalculateRentersUpdateProrated = {
  __typename?: 'CalculateRentersUpdateProrated';
  new_price: Scalars['Float']['output'];
  original_price: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
};

export type CalculateRentersUpdateResponse = {
  __typename?: 'CalculateRentersUpdateResponse';
  next_policy?: Maybe<CalculateRentersUpdateNextPolicy>;
  operation: CalculateRentersUpdateOperationEnum;
  previous_policy?: Maybe<CalculcateRentersUpdatePreviousPolicy>;
  prorated?: Maybe<CalculateRentersUpdateProrated>;
};

export type CalculcateRentersUpdatePreviousPolicy = {
  __typename?: 'CalculcateRentersUpdatePreviousPolicy';
  coverage_end_date: Scalars['String']['output'];
  flat_cancel: Scalars['Boolean']['output'];
  months_refunded: Scalars['Int']['output'];
  payments_remaining: Scalars['Int']['output'];
  policy_end_date: Scalars['String']['output'];
  refund_amount: Scalars['Float']['output'];
};

export type CancelRentersMembershipInput = {
  cancelReason?: InputMaybe<Scalars['String']['input']>;
  lastActiveDate?: InputMaybe<Scalars['String']['input']>;
  membershipGroupId?: InputMaybe<Scalars['Int']['input']>;
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type CancelRentersMembershipResponse = {
  __typename?: 'CancelRentersMembershipResponse';
  coverageEndDate: Scalars['String']['output'];
  flatCancel: Scalars['Boolean']['output'];
  isRefunded: Scalars['Boolean']['output'];
  monthsRefunded: Scalars['Int']['output'];
  paymentsRemaining: Scalars['Int']['output'];
  policyEndDate: Scalars['String']['output'];
  prorationRefunds: Array<Maybe<Scalars['String']['output']>>;
  refundAmount: Scalars['Float']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  contact_flag: Scalars['Int']['output'];
  contact_status: Scalars['String']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  created_by_type?: Maybe<Scalars['String']['output']>;
  creation_time: Scalars['DateTime']['output'];
  domain: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_update_by?: Maybe<Scalars['Int']['output']>;
  last_update_by_type?: Maybe<Scalars['String']['output']>;
  last_update_reason?: Maybe<Scalars['String']['output']>;
  last_update_time: Scalars['DateTime']['output'];
  phone_country_id?: Maybe<Scalars['Int']['output']>;
  primary_flag: Scalars['Int']['output'];
  record_status: Scalars['String']['output'];
  sms_flag: Scalars['Int']['output'];
  target_id: Scalars['Int']['output'];
  target_obj: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CreditCardInput = {
  account_number: Scalars['String']['input'];
  cvc: Scalars['String']['input'];
  exp_month: Scalars['String']['input'];
  exp_year: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
};

export type Entity = {
  __typename?: 'Entity';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  address_city: Scalars['String']['output'];
  address_country?: Maybe<Scalars['String']['output']>;
  address_state: Scalars['String']['output'];
  address_zip: Scalars['String']['output'];
  contactPrimaryEmail?: Maybe<Contact>;
  contactPrimaryPhone?: Maybe<Contact>;
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faberPolicies?: Maybe<Array<FaberPolicy>>;
  first_name: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  hasKamino?: Maybe<Scalars['Boolean']['output']>;
  hasRenters?: Maybe<Scalars['Boolean']['output']>;
  hasSkypad?: Maybe<Scalars['Boolean']['output']>;
  hasTuition?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  kaminoPolicies: Array<KaminoPolicy>;
  lastRentersPolicy?: Maybe<LastRentersPolicy>;
  lastTuitionPolicy?: Maybe<FaberPolicy>;
  last_name: Scalars['String']['output'];
  middle_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phone_country_id?: Maybe<Scalars['Int']['output']>;
  preferred_name?: Maybe<Scalars['String']['output']>;
  property_id?: Maybe<Scalars['Int']['output']>;
  requiresMfa?: Maybe<Scalars['Boolean']['output']>;
  school: Scalars['String']['output'];
  school_id?: Maybe<Scalars['Int']['output']>;
  sessionImpersonation?: Maybe<Scalars['Boolean']['output']>;
  showRentersCrossSell?: Maybe<Scalars['Boolean']['output']>;
  showTuitionCrossSell?: Maybe<Scalars['Boolean']['output']>;
  /**  Relationships  */
  skypadPolicies?: Maybe<Array<SkypadPolicy>>;
  sms_phone?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type FaberInsured = {
  __typename?: 'FaberInsured';
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  address_city: Scalars['String']['output'];
  address_country: Scalars['String']['output'];
  address_state: Scalars['String']['output'];
  address_zip: Scalars['String']['output'];
  client_id: Scalars['Int']['output'];
  creation_time: Scalars['DateTime']['output'];
  dob: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  external_insured_cd: Scalars['String']['output'];
  external_insured_id: Scalars['Int']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  insured_status: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  last_update_by: Scalars['Int']['output'];
  last_update_reason?: Maybe<Scalars['String']['output']>;
  last_updated_time: Scalars['DateTime']['output'];
  phone: Scalars['String']['output'];
  policy_id: Scalars['Int']['output'];
  record_status: Scalars['String']['output'];
  school_id: Scalars['Int']['output'];
  years_in_school: Scalars['Int']['output'];
};

export type FaberPaymentMethod = {
  __typename?: 'FaberPaymentMethod';
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  address_city: Scalars['String']['output'];
  address_country: Scalars['String']['output'];
  address_state: Scalars['String']['output'];
  address_zip: Scalars['String']['output'];
  exp_month: Scalars['String']['output'];
  exp_year: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_four: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  payment_method_brand: Scalars['String']['output'];
  payment_method_status: FaberPaymentMethodStatus;
};

export enum FaberPaymentMethodStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  OnFile = 'ON_FILE'
}

export type FaberPaymentTransaction = {
  __typename?: 'FaberPaymentTransaction';
  amount: Scalars['Float']['output'];
  charge_date?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  external_transaction_id: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  paymentMethod: FaberPaymentMethod;
  payment_status: FaberPaymentTransactionPaymentStatus;
  policy?: Maybe<FaberPolicy>;
};

/** A paginated list of FaberPaymentTransaction items. */
export type FaberPaymentTransactionPaginator = {
  __typename?: 'FaberPaymentTransactionPaginator';
  /** A list of FaberPaymentTransaction items. */
  data: Array<FaberPaymentTransaction>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum FaberPaymentTransactionPaymentStatus {
  Active = 'active',
  Failed = 'failed',
  Inactive = 'inactive',
  Pending = 'pending',
  Succeeded = 'succeeded',
  Voided = 'voided'
}

export type FaberPaymentsTransactionInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type FaberPolicy = {
  __typename?: 'FaberPolicy';
  account_id: Scalars['Int']['output'];
  /**  'faber','allianz'  */
  admin_system: Scalars['String']['output'];
  canFileClaim: Scalars['Boolean']['output'];
  cancellation_date?: Maybe<Scalars['String']['output']>;
  cancellation_reason?: Maybe<Scalars['String']['output']>;
  cancellation_received?: Maybe<Scalars['String']['output']>;
  /**  'cortana','mma','allianz'  */
  cancellation_source?: Maybe<Scalars['String']['output']>;
  client_id: Scalars['Int']['output'];
  coverage_amount?: Maybe<Scalars['Int']['output']>;
  creation_time?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<PolicyDocumentsResponse>>;
  end_date: Scalars['String']['output'];
  fulfillment_time?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  insured: FaberInsured;
  isImported: Scalars['Boolean']['output'];
  lastPaymentFailed?: Maybe<FaberPaymentTransaction>;
  neverCovered: Scalars['Boolean']['output'];
  payment_transaction_id?: Maybe<Scalars['Int']['output']>;
  policy_number: Scalars['String']['output'];
  /**  'active','inactive','suspended','expired','cancelled','preactive','perm-suspended','pending','payment_failed','stuck_policy'  */
  policy_status: FaberPolicyStatus;
  prev_policy_number?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  product_id: Scalars['String']['output'];
  quoteResponse?: Maybe<FaberQuoteResponse>;
  quote_response_id: Scalars['Int']['output'];
  school: School;
  showCancel: Scalars['Boolean']['output'];
  start_date: Scalars['String']['output'];
  term_name?: Maybe<Scalars['String']['output']>;
};

export enum FaberPolicyStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Expired = 'Expired',
  Inactive = 'Inactive',
  PaymentFailed = 'PaymentFailed',
  Pending = 'Pending',
  PermSuspended = 'PermSuspended',
  Preactive = 'Preactive',
  StuckPolicy = 'StuckPolicy'
}

export type FaberQuoteResponse = {
  __typename?: 'FaberQuoteResponse';
  allianz_quote_id: Scalars['String']['output'];
  client_id: Scalars['Int']['output'];
  coverage_amount: Scalars['Int']['output'];
  creation_time: Scalars['DateTime']['output'];
  cxid?: Maybe<Scalars['Int']['output']>;
  external_student_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_update_by: Scalars['Int']['output'];
  last_update_reason?: Maybe<Scalars['String']['output']>;
  last_updated_time: Scalars['DateTime']['output'];
  offer_id: Scalars['Int']['output'];
  offer_language: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  product_id: Scalars['String']['output'];
  quote_response_status?: Maybe<Scalars['String']['output']>;
  quote_transaction_id?: Maybe<Scalars['String']['output']>;
  record_status: Scalars['String']['output'];
  region: Scalars['String']['output'];
  response_id?: Maybe<Scalars['Int']['output']>;
  school_id: Scalars['Int']['output'];
  session_id?: Maybe<Scalars['String']['output']>;
  study_abroad: Scalars['String']['output'];
  term_end: Scalars['Date']['output'];
  term_name?: Maybe<Scalars['String']['output']>;
  term_start: Scalars['Date']['output'];
  term_type?: Maybe<Scalars['String']['output']>;
};

export type FaberRefundTransaction = {
  __typename?: 'FaberRefundTransaction';
  amount_refunded: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  refund_reason: Scalars['String']['output'];
  refund_time?: Maybe<Scalars['DateTime']['output']>;
  refund_transaction_status: FaberRefundTransactionStatus;
};

export enum FaberRefundTransactionStatus {
  Pending = 'pending',
  Succeeded = 'succeeded'
}

export type FileRentersClaimInput = {
  claimant_info?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  insured_name: Scalars['String']['input'];
  loss_date: Scalars['String']['input'];
  loss_description: Scalars['String']['input'];
  loss_location: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  policy_number: Scalars['String']['input'];
};

export enum InsuranceType {
  Renters = 'RENTERS',
  Tuition = 'TUITION'
}

export type InsuredDataInfoInput = {
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  insured_dob: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_country_id?: InputMaybe<Scalars['Int']['input']>;
  preferred_name?: InputMaybe<Scalars['String']['input']>;
  sms_flag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InterestPartyInput = {
  address?: InputMaybe<AddressInput>;
  profile: InterestPartyProfileInput;
};

export type InterestPartyProfileInput = {
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export enum InterestedPartyTypeEnum {
  Company = 'company',
  Person = 'person'
}

export type InternationalAddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  address_city?: InputMaybe<Scalars['String']['input']>;
  address_country: Scalars['String']['input'];
  address_state?: InputMaybe<Scalars['String']['input']>;
  address_zip?: InputMaybe<Scalars['String']['input']>;
};

export type KaminoAddress = {
  __typename?: 'KaminoAddress';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type KaminoCancellationReasonCode = {
  __typename?: 'KaminoCancellationReasonCode';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type KaminoFnolContactInput = {
  doNotHaveContactInfo?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneCountryId?: InputMaybe<Scalars['Int']['input']>;
  type: KaminoFnolContactType;
};

export enum KaminoFnolContactType {
  Injured = 'Injured',
  Witness = 'Witness'
}

export enum KaminoFnolInputBestContactTime {
  Afternoon = 'afternoon',
  Anytime = 'anytime',
  Evening = 'evening',
  Morning = 'morning',
  Weekends = 'weekends'
}

export enum KaminoFnolInputLossProperty {
  AnotherPersonsProperty = 'anotherPersonsProperty',
  InjuryToAnotherPerson = 'injuryToAnotherPerson',
  MyProperty = 'myProperty'
}

export enum KaminoFnolInputRelationship {
  AccountHolder = 'accountHolder',
  Insured = 'insured',
  InterestedParty = 'interestedParty',
  Other = 'other',
  School = 'school'
}

export type KaminoFnolCreateInput = {
  address: InternationalAddressInput;
  addressFullAddress: Scalars['String']['input'];
  bestContactTime: KaminoFnolInputBestContactTime;
  comments: Scalars['String']['input'];
  contacts?: InputMaybe<Array<KaminoFnolContactInput>>;
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  injuredOtherPerson?: InputMaybe<Scalars['Boolean']['input']>;
  lossDate: Scalars['String']['input'];
  lossPlace: InternationalAddressInput;
  lossPlaceFullAddress: Scalars['String']['input'];
  lossProperty: KaminoFnolInputLossProperty;
  otherStructures?: InputMaybe<Scalars['Boolean']['input']>;
  phone: Scalars['String']['input'];
  phoneCountryId: Scalars['Int']['input'];
  policyNumber: Scalars['String']['input'];
  presentPersonInjured?: InputMaybe<Scalars['Boolean']['input']>;
  relationship: KaminoFnolInputRelationship;
};

export type KaminoInsuredPerson = {
  __typename?: 'KaminoInsuredPerson';
  core_entity_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  kamino_insureds_uuid: Scalars['String']['output'];
  kamino_person_uuid: Scalars['String']['output'];
  person: KaminoPerson;
  person_type: KaminoPersonType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type KaminoInsureds = {
  __typename?: 'KaminoInsureds';
  additionalInsureds: Array<KaminoInsuredPerson>;
  address: KaminoAddress;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  effective_date: Scalars['Date']['output'];
  is_on_campus: Scalars['Int']['output'];
  is_preferred: Scalars['Int']['output'];
  kamino_address_uuid: Scalars['String']['output'];
  primaryInsured: KaminoInsuredPerson;
  property_external_cd: Scalars['String']['output'];
  property_external_id: Scalars['Int']['output'];
  school: School;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type KaminoInterestedParty = {
  __typename?: 'KaminoInterestedParty';
  address?: Maybe<KaminoAddress>;
  effective_date?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  expiration_date?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  phone_country_id?: Maybe<Scalars['String']['output']>;
  type: InterestedPartyTypeEnum;
  uuid: Scalars['String']['output'];
};

export type KaminoPaymentMethod = {
  __typename?: 'KaminoPaymentMethod';
  address: KaminoAddress;
  exp_month?: Maybe<Scalars['String']['output']>;
  exp_year?: Maybe<Scalars['String']['output']>;
  last_four?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  payment_method_brand?: Maybe<Scalars['String']['output']>;
  payment_method_type: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type KaminoPerson = {
  __typename?: 'KaminoPerson';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export enum KaminoPersonType {
  AdditionalInsured = 'additional_insured',
  PrimaryInsured = 'primary_insured'
}

export type KaminoPolicy = {
  __typename?: 'KaminoPolicy';
  canFileClaim: Scalars['Boolean']['output'];
  canSuspend: Scalars['Boolean']['output'];
  confirmation_number: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  details: KaminoPolicyDetails;
  documents?: Maybe<Array<PolicyDocumentsResponse>>;
  enrollment_date?: Maybe<Scalars['Date']['output']>;
  interestedParty?: Maybe<KaminoInterestedParty>;
  isAutoRenew: Scalars['Boolean']['output'];
  isModifiable: Scalars['Boolean']['output'];
  isMonthly: Scalars['Boolean']['output'];
  is_auto_renew: Scalars['Boolean']['output'];
  kamino_account_holder_uuid: Scalars['String']['output'];
  lastPolicyTransaction: KaminoPolicyTransaction;
  neverCovered: Scalars['Boolean']['output'];
  payment_interval: Scalars['Int']['output'];
  policyNumber: Scalars['String']['output'];
  policy_end_date?: Maybe<Scalars['Date']['output']>;
  policy_number?: Maybe<Scalars['String']['output']>;
  policy_start_date: Scalars['Date']['output'];
  policy_status: KaminoPolicyStatus;
  previous_policy_number?: Maybe<Scalars['String']['output']>;
  subscriptions?: Maybe<Array<KaminoSubscription>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};


export type KaminoPolicyIsModifiableArgs = {
  effective_date?: InputMaybe<Scalars['Date']['input']>;
};

export type KaminoPolicyCoverages = {
  __typename?: 'KaminoPolicyCoverages';
  bedbug_limit: Scalars['Int']['output'];
  deductible: Scalars['Int']['output'];
  earthquake_limit: Scalars['Int']['output'];
  liability_limit: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  property_limit: Scalars['Int']['output'];
  scheduled_property_limit: Scalars['Int']['output'];
};

export type KaminoPolicyDetails = {
  __typename?: 'KaminoPolicyDetails';
  coverages: KaminoPolicyCoverages;
  next_amount_due: Scalars['Float']['output'];
  subscription_price: Scalars['Float']['output'];
};

export enum KaminoPolicyStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Draft = 'draft',
  Expired = 'expired',
  Inactive = 'inactive',
  Pending = 'pending',
  PermCancelled = 'permCancelled',
  PermSuspended = 'permSuspended',
  PreCancelled = 'preCancelled',
  Preactive = 'preactive',
  Predisbursement = 'predisbursement',
  Suspended = 'suspended',
  Unpaid = 'unpaid'
}

export type KaminoPolicyTransaction = {
  __typename?: 'KaminoPolicyTransaction';
  coverages: KaminoPolicyCoverages;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  insured: KaminoInsureds;
  kamino_cancel_reason_code?: Maybe<Scalars['String']['output']>;
  kamino_coverage_uuid: Scalars['String']['output'];
  kamino_insureds_uuid: Scalars['String']['output'];
  kamino_payment_transaction_uuid?: Maybe<Scalars['String']['output']>;
  kamino_policy_uuid: Scalars['String']['output'];
  kamino_refund_intent_uuid?: Maybe<Scalars['String']['output']>;
  kamino_subscription_uuid?: Maybe<Scalars['String']['output']>;
  kamino_transaction_type: TransactionTypeEnum;
  next_pay_date?: Maybe<Scalars['String']['output']>;
  transaction_effective_datetime: Scalars['DateTime']['output'];
  transaction_initiated_datetime: Scalars['DateTime']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type KaminoSubscription = {
  __typename?: 'KaminoSubscription';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  kamino_payment_method_uuid: Scalars['String']['output'];
  kamino_policy_uuid: Scalars['String']['output'];
  kamino_subscription_schedule_uuid?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<KaminoPaymentMethod>;
  stripe_subscription_id?: Maybe<Scalars['String']['output']>;
  stripe_subscription_status?: Maybe<Scalars['String']['output']>;
  subscription_status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type LastRentersPolicy = {
  __typename?: 'LastRentersPolicy';
  kamino?: Maybe<KaminoPolicy>;
  skypad?: Maybe<SkypadPolicy>;
};

export type Membership = {
  __typename?: 'Membership';
  /**  'gradguard','skypad','allianz','faber'  */
  admin_system?: Maybe<Scalars['String']['output']>;
  adv_payment_interval: Scalars['Int']['output'];
  agent_id?: Maybe<Scalars['Int']['output']>;
  /**  'yes','no','renewed'  */
  auto_renew: Scalars['String']['output'];
  client_id?: Maybe<Scalars['Int']['output']>;
  coverage_end_date?: Maybe<Scalars['String']['output']>;
  coverage_start_date?: Maybe<Scalars['String']['output']>;
  covered_terms?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['Int']['output']>;
  created_by_type?: Maybe<Scalars['String']['output']>;
  creation_time?: Maybe<Scalars['String']['output']>;
  deductible?: Maybe<Scalars['Int']['output']>;
  dtd_code?: Maybe<Scalars['String']['output']>;
  end_month_balance: Scalars['Int']['output'];
  enrollment_date?: Maybe<Scalars['String']['output']>;
  /**  Relationships  */
  entity: Entity;
  entity_id: Scalars['Int']['output'];
  fail_count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /**  'tuition','health','renters'  */
  insurance_type?: Maybe<Scalars['String']['output']>;
  last_update_by?: Maybe<Scalars['Int']['output']>;
  /**  'agent_table','user_table','entity_table'  */
  last_update_by_type?: Maybe<Scalars['String']['output']>;
  last_update_reason?: Maybe<Scalars['String']['output']>;
  last_update_time?: Maybe<Scalars['String']['output']>;
  loss_payee?: Maybe<Scalars['String']['output']>;
  max_benefit: Scalars['Int']['output'];
  membership_group_id: Scalars['Int']['output'];
  /**  'site','bossman','knutsenator','bulkload','cortana','aga_import','tms_import','rpp','api'  */
  membership_source: Scalars['String']['output'];
  /**  'active','inactive','expired','suspended','perm-suspended','cancelled','preactive','preactive-tuition','perm-cancelled','pre-cancelled','unpaid','predisbursement','pending','payment_failed','stuck_policy'  */
  membership_status: Scalars['String']['output'];
  /**  Accessors  */
  mma_status_box: Scalars['String']['output'];
  next_pay_date?: Maybe<Scalars['String']['output']>;
  num_dependents: Scalars['Int']['output'];
  num_spouses: Scalars['Int']['output'];
  orig_plan_id: Scalars['Int']['output'];
  orig_sku_id?: Maybe<Scalars['Int']['output']>;
  payment_interval: Scalars['Int']['output'];
  payment_method_id: Scalars['Int']['output'];
  payments_remaining: Scalars['Int']['output'];
  policy_number?: Maybe<Scalars['String']['output']>;
  prev_policy_number?: Maybe<Scalars['String']['output']>;
  price_recurring: Scalars['Float']['output'];
  price_start: Scalars['Float']['output'];
  /**  'Tuition Refund Insurance','Graduation Plan','Tuition Payment Plan','Renters Property','Renters Liability','Renters Earthquake','SPP','Health','Allianz Tuition Insurance','Tuition Protection Plan','Tuition Essential Plan','Tuition Preferred Plan','Tuition Advantage Plan','Multi-Term Tuition Protection Plan','Multi-Term Preferred Plan','None'  */
  product_type?: Maybe<Scalars['String']['output']>;
  program_season: Scalars['String']['output'];
  program_term?: Maybe<Scalars['String']['output']>;
  /**  'active','inactive'  */
  record_status: Scalars['String']['output'];
  start_date?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  total_payments: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
};

export type MessageResponse = {
  __typename?: 'MessageResponse';
  message: Scalars['String']['output'];
  type: MessageResponseType;
};

export type MessageResponseLoginDataManageMyAccount = {
  __typename?: 'MessageResponseLoginDataManageMyAccount';
  mfaSentTo?: Maybe<MfaSentTo>;
  mfaShowWarning: Scalars['Boolean']['output'];
  requiresMfa: Scalars['Boolean']['output'];
};

export type MessageResponseLoginManageMyAccount = {
  __typename?: 'MessageResponseLoginManageMyAccount';
  data: MessageResponseLoginDataManageMyAccount;
  message: Scalars['String']['output'];
  type: MessageResponseType;
};

export type MessageResponseSession = {
  __typename?: 'MessageResponseSession';
  data: MessageResponseSessionData;
  message: Scalars['String']['output'];
  type: MessageResponseType;
};

export type MessageResponseSessionData = {
  __typename?: 'MessageResponseSessionData';
  hasPhone: Scalars['Boolean']['output'];
  requiresMfa: Scalars['Boolean']['output'];
};

export enum MessageResponseType {
  Error = 'error',
  Success = 'success',
  Warning = 'warning'
}

export enum MfaSentTo {
  Email = 'email',
  Phone = 'phone'
}

export type MmaLoggedUser = Entity | User;

export type Moratorium = {
  __typename?: 'Moratorium';
  city: Scalars['String']['output'];
  county: Scalars['String']['output'];
  end_date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  moratorium_status?: Maybe<Scalars['String']['output']>;
  moratorium_type?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  cancelRentersMembership: CancelRentersMembershipResponse;
  fileRentersClaim?: Maybe<MessageResponse>;
  kaminoFnolCreate?: Maybe<MessageResponse>;
  kaminoPaymentMethodSave: Scalars['Boolean']['output'];
  rentersPolicyUpdate?: Maybe<RentersPolicyUpdateResponse>;
  tuitionPolicyCancel?: Maybe<TuitionPolicyCancelResponse>;
  updateEntityContactInfo?: Maybe<Entity>;
  updateRentersPaymentMethod?: Maybe<SkypadPaymentMethod>;
  updateTuitionPaymentMethodACH?: Maybe<MessageResponse>;
  updateTuitionPaymentMethodCreditCard?: Maybe<MessageResponse>;
  updateUserContactInfo?: Maybe<User>;
};


export type MutationCancelRentersMembershipArgs = {
  input?: InputMaybe<CancelRentersMembershipInput>;
};


export type MutationFileRentersClaimArgs = {
  input: FileRentersClaimInput;
};


export type MutationKaminoFnolCreateArgs = {
  input: KaminoFnolCreateInput;
};


export type MutationKaminoPaymentMethodSaveArgs = {
  paymentMethod: Scalars['String']['input'];
};


export type MutationRentersPolicyUpdateArgs = {
  input: RentersPolicyUpdateInput;
};


export type MutationTuitionPolicyCancelArgs = {
  input: TuitionPolicyCancelInput;
};


export type MutationUpdateEntityContactInfoArgs = {
  basicInfo: ProfileBasicInfoInput;
  entityId: Scalars['Int']['input'];
};


export type MutationUpdateRentersPaymentMethodArgs = {
  address: InternationalAddressInput;
  creditCard: CreditCardInput;
  overdue: Scalars['Boolean']['input'];
};


export type MutationUpdateTuitionPaymentMethodAchArgs = {
  ach: AchInput;
  address: InternationalAddressInput;
  overdue: Scalars['Boolean']['input'];
};


export type MutationUpdateTuitionPaymentMethodCreditCardArgs = {
  address: InternationalAddressInput;
  creditCard: CreditCardInput;
  overdue: Scalars['Boolean']['input'];
};


export type MutationUpdateUserContactInfoArgs = {
  basicInfo: ProfileBasicInfoInput;
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
  /** Number of total available items. */
  total: Scalars['Int']['output'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  brand?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['String']['output']>;
  expYear?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastFour?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: PaymentMethodTypeEnum;
};

export enum PaymentMethodTypeEnum {
  Ach = 'ach',
  ApplePay = 'apple_pay',
  BankAccount = 'bank_account',
  Card = 'card',
  Cc = 'cc',
  GooglePay = 'google_pay',
  HeartlandAch = 'heartland_ach',
  HeartlandCc = 'heartland_cc'
}

export type PaymentPolicies = {
  __typename?: 'PaymentPolicies';
  id: Scalars['String']['output'];
  policyNumber: Scalars['String']['output'];
};

export type PaymentRefund = {
  __typename?: 'PaymentRefund';
  amount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  refundDatetime?: Maybe<Scalars['DateTime']['output']>;
  refundReason?: Maybe<Scalars['String']['output']>;
  refundStatus?: Maybe<Scalars['String']['output']>;
};

export type PaymentTotalRefund = {
  __typename?: 'PaymentTotalRefund';
  amount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum PaymentTransactionStatus {
  Active = 'active',
  Failed = 'failed',
  Inactive = 'inactive',
  Pending = 'pending',
  Succeeded = 'succeeded',
  Voided = 'voided'
}

export type PaymentTransactionsSearchInput = {
  showFaber?: InputMaybe<Scalars['Boolean']['input']>;
  showKamino?: InputMaybe<Scalars['Boolean']['input']>;
  showSkypad?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Payments = {
  __typename?: 'Payments';
  amount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  paymentMethod?: Maybe<PaymentMethod>;
  policies: Array<PaymentPolicies>;
  refunds: Array<PaymentRefund>;
  totalRefund: PaymentTotalRefund;
  transactionDatetime?: Maybe<Scalars['DateTime']['output']>;
  transactionStatus?: Maybe<PaymentTransactionStatus>;
  type: Scalars['String']['output'];
};

export type PolicyCardMembership = {
  __typename?: 'PolicyCardMembership';
  coverage_end_date: Scalars['String']['output'];
  coverage_start_date: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  first_name: Scalars['String']['output'];
  insurance_type: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  membership_source: Scalars['String']['output'];
  membership_status: Scalars['String']['output'];
  mma_status_box: Scalars['String']['output'];
  next_pay_date: Scalars['String']['output'];
  policy_number: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
};

export type ProfileBasicInfoInput = {
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_country_id?: InputMaybe<Scalars['Int']['input']>;
  preferred_name?: InputMaybe<Scalars['String']['input']>;
  sms_flag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Property = {
  __typename?: 'Property';
  address1?: Maybe<Scalars['String']['output']>;
  address2: Scalars['String']['output'];
  address_city?: Maybe<Scalars['String']['output']>;
  address_country: Scalars['String']['output'];
  address_state?: Maybe<Scalars['String']['output']>;
  address_zip?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  property_name?: Maybe<Scalars['String']['output']>;
  property_status: Scalars['String']['output'];
  school_id?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  calculateRentersCancel?: Maybe<CalculateRentersCancelResponse>;
  calculateRentersUpdate?: Maybe<CalculateRentersUpdateResponse>;
  entity: Entity;
  /**  @deprecated Use paymentTransactions instead  */
  faberPaymentsTransaction: FaberPaymentTransactionPaginator;
  getFaberPaymentMethodBySession: FaberPaymentMethod;
  getSkypadPaymentMethodBySession?: Maybe<SkypadPaymentMethod>;
  kaminoCancellationReasonCodes: Array<KaminoCancellationReasonCode>;
  kaminoPaymentMethod?: Maybe<KaminoPaymentMethod>;
  mmaLogged?: Maybe<MmaLoggedUser>;
  paymentTransactions: Array<Payments>;
  rentersCertificate?: Maybe<RentersCertificateResponse>;
  rentersStartingAtQuote: RentersStartingAtQuoteType;
  rentersUpdateQuoteQuery: RentersQuote;
  schools: SchoolPaginator;
  /**  @deprecated Use paymentTransactions instead  */
  skypadPaymentsTransaction: SkypadPaymentTransactionPaginator;
  stripeSetupIntent: Scalars['String']['output'];
  tuitionStartingAtQuote?: Maybe<TuitionQuoteTerm>;
};


export type QueryCalculateRentersCancelArgs = {
  input: CalculateRentersCancelInput;
};


export type QueryCalculateRentersUpdateArgs = {
  input: CalculateRentersUpdateInput;
};


export type QueryEntityArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryFaberPaymentsTransactionArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<FaberPaymentsTransactionInput>;
};


export type QueryKaminoCancellationReasonCodesArgs = {
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaymentTransactionsArgs = {
  search?: InputMaybe<PaymentTransactionsSearchInput>;
};


export type QueryRentersCertificateArgs = {
  policyNumber: Scalars['String']['input'];
  showDraft?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRentersStartingAtQuoteArgs = {
  schoolId: Scalars['Int']['input'];
};


export type QueryRentersUpdateQuoteQueryArgs = {
  input: RentersQuoteInput;
  policyNumber: Scalars['String']['input'];
};


export type QuerySchoolsArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<SchoolSearchInput>;
};


export type QuerySkypadPaymentsTransactionArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<SkypadPaymentsTransactionInput>;
};


export type QueryTuitionStartingAtQuoteArgs = {
  schoolId: Scalars['Int']['input'];
};

export type RefCodeTerm = {
  __typename?: 'RefCodeTerm';
  daysRemaining?: Maybe<Scalars['Int']['output']>;
  default_coverage: Scalars['Int']['output'];
  extension_date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  min_coverage: Scalars['Int']['output'];
  offer_open_date?: Maybe<Scalars['Date']['output']>;
  ref_code_id: Scalars['Int']['output'];
  term_end?: Maybe<Scalars['Date']['output']>;
  term_name: Scalars['String']['output'];
  term_start?: Maybe<Scalars['Date']['output']>;
  term_type?: Maybe<TermTypesEnum>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type RentersCertificateResponse = {
  __typename?: 'RentersCertificateResponse';
  body: Scalars['String']['output'];
  style: Scalars['String']['output'];
};

export type RentersPolicyInput = {
  autorenew: Scalars['Boolean']['input'];
  deductible: Scalars['Int']['input'];
  earthquake: Scalars['Boolean']['input'];
  liabilityCoverage: Scalars['Int']['input'];
  onCampus: Scalars['Boolean']['input'];
  paymentInterval: Scalars['Int']['input'];
  preferred: Scalars['Boolean']['input'];
  propertyCoverage: Scalars['Int']['input'];
  sprinklerCredit: SprinklerEnum;
  startDate: Scalars['String']['input'];
};

export type RentersPolicyUpdateInput = {
  coverage: RentersPolicyInput;
  insured: InsuredDataInfoInput;
  insuredAddress: AddressInput;
  ip?: InputMaybe<InterestPartyInput>;
  policyNumber: Scalars['String']['input'];
  schoolId: Scalars['Int']['input'];
};

export type RentersPolicyUpdateResponse = {
  __typename?: 'RentersPolicyUpdateResponse';
  isCancelRewrite: Scalars['Boolean']['output'];
  policyNumber: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type RentersQuote = {
  __typename?: 'RentersQuote';
  admin_fee: RentersQuoteAdminFee;
  billing_fee_total: Scalars['Float']['output'];
  deductible: Scalars['Float']['output'];
  earthquake_limit: Scalars['Float']['output'];
  earthquake_pretax: Scalars['Float']['output'];
  earthquake_price: Scalars['Float']['output'];
  hurricane_limit: Scalars['Float']['output'];
  hurricane_pretax: Scalars['Float']['output'];
  hurricane_price: Scalars['Float']['output'];
  is_bill_me_later: Scalars['Boolean']['output'];
  liability_limit: Scalars['Float']['output'];
  liability_pretax: Scalars['Float']['output'];
  liability_price: Scalars['Float']['output'];
  moratorium?: Maybe<Moratorium>;
  payments: RentersQuotePayments;
  price: Scalars['Float']['output'];
  product_fees: RentersQuoteProductFees;
  property_limit: Scalars['Float']['output'];
  property_pretax: Scalars['Float']['output'];
  property_price: Scalars['Float']['output'];
  provider: RentersQuoteProviderEnum;
  subscription_price: Scalars['Float']['output'];
  surcharges: Array<RentersQuoteSurcharge>;
  term: Scalars['Int']['output'];
};

export type RentersQuoteAdminFee = {
  __typename?: 'RentersQuoteAdminFee';
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  statement_descriptor: Scalars['String']['output'];
};

export type RentersQuoteInput = {
  deductible: Scalars['Int']['input'];
  earthquake_coverage: Scalars['Int']['input'];
  insured_city: Scalars['String']['input'];
  insured_state: Scalars['String']['input'];
  insured_zip: Scalars['String']['input'];
  liability_coverage: Scalars['Int']['input'];
  payment_interval: Scalars['Int']['input'];
  preferred: Scalars['Boolean']['input'];
  property_coverage: Scalars['Int']['input'];
  sprinkler_credit?: InputMaybe<SprinklerEnum>;
  start_date: Scalars['String']['input'];
};

export type RentersQuoteParams = {
  __typename?: 'RentersQuoteParams';
  deductible: Scalars['Int']['output'];
  earthquake_coverage: Scalars['Int']['output'];
  endorsements: Scalars['String']['output'];
  insured_city: Scalars['String']['output'];
  insured_state: Scalars['String']['output'];
  insured_zip: Scalars['String']['output'];
  liability_coverage: Scalars['Int']['output'];
  payment_interval: Scalars['String']['output'];
  preferred: Scalars['Boolean']['output'];
  property_coverage: Scalars['Int']['output'];
  sprinkler_credit: Scalars['String']['output'];
  start_date: Scalars['String']['output'];
};

export type RentersQuotePayment = {
  __typename?: 'RentersQuotePayment';
  admin_fee: Scalars['Float']['output'];
  billing_fee: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  display_price: Scalars['Float']['output'];
  surcharges: Scalars['Float']['output'];
};

export type RentersQuotePayments = {
  __typename?: 'RentersQuotePayments';
  first_payment: RentersQuotePayment;
  pause_resume_first_payment: RentersQuotePayment;
  second_payment: RentersQuotePayment;
};

export type RentersQuoteProductFees = {
  __typename?: 'RentersQuoteProductFees';
  earthquake: Scalars['Float']['output'];
  hurricane: Scalars['Float']['output'];
  liability: Scalars['Float']['output'];
  property: Scalars['Float']['output'];
};

export enum RentersQuoteProviderEnum {
  Kamino = 'kamino',
  Skypad = 'skypad'
}

export type RentersQuoteSurcharge = {
  __typename?: 'RentersQuoteSurcharge';
  amount: Scalars['Float']['output'];
  modal_acknowledgement: Scalars['String']['output'];
  modal_description: Scalars['String']['output'];
  modal_title: Scalars['String']['output'];
  name: Scalars['String']['output'];
  statement_descriptor: Scalars['String']['output'];
};

export type RentersStartingAtQuoteType = {
  __typename?: 'RentersStartingAtQuoteType';
  quote: RentersQuote;
  quoteParams: RentersQuoteParams;
};

export type School = {
  __typename?: 'School';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  address_city: Scalars['String']['output'];
  address_country: Scalars['String']['output'];
  address_state: Scalars['String']['output'];
  address_zip: Scalars['String']['output'];
  hasRentersImplementationActive: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  logo_url?: Maybe<Scalars['String']['output']>;
  school_name: Scalars['String']['output'];
  school_status: Scalars['String']['output'];
  show_renters: Scalars['Boolean']['output'];
  show_tuition: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
  website_url?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of School items. */
export type SchoolPaginator = {
  __typename?: 'SchoolPaginator';
  /** A list of School items. */
  data: Array<School>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SchoolSearchInput = {
  school_name?: InputMaybe<Scalars['String']['input']>;
  show_renters?: InputMaybe<Scalars['Boolean']['input']>;
  show_tuition?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkypadCalculateRefund = {
  __typename?: 'SkypadCalculateRefund';
  id: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  refunded: Scalars['Float']['output'];
  times: Scalars['Int']['output'];
  type: SkypadCalculateRefundType;
};

export enum SkypadCalculateRefundType {
  Full = 'full',
  Partial = 'partial'
}

/** SkypadInsured is the type "primary" only. It doesn't not include the `additional` or `interested_party` type. */
export type SkypadInsured = {
  __typename?: 'SkypadInsured';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  address_city: Scalars['String']['output'];
  address_country: Scalars['String']['output'];
  address_state: Scalars['String']['output'];
  address_zip: Scalars['String']['output'];
  allowEarthquake: Scalars['Boolean']['output'];
  creation_time: Scalars['DateTime']['output'];
  dob?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  external_cd: Scalars['String']['output'];
  external_id: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  insured_status: Scalars['String']['output'];
  insured_type: SkypadPrimaryInsuredEnum;
  isOnCampus: Scalars['Boolean']['output'];
  last_name: Scalars['String']['output'];
  last_update_by?: Maybe<Scalars['Int']['output']>;
  last_update_reason?: Maybe<Scalars['String']['output']>;
  last_update_time: Scalars['DateTime']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  policy_id: Scalars['Int']['output'];
  property?: Maybe<Property>;
  property_external_cd?: Maybe<Scalars['String']['output']>;
  property_external_id?: Maybe<Scalars['String']['output']>;
  property_name: Scalars['String']['output'];
  property_owner: Scalars['String']['output'];
  record_status: Scalars['String']['output'];
  school?: Maybe<School>;
};

/** SkypadInsured is the type "additional" only. */
export type SkypadInterestedPartyInsured = {
  __typename?: 'SkypadInterestedPartyInsured';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address_city?: Maybe<Scalars['String']['output']>;
  address_country?: Maybe<Scalars['String']['output']>;
  address_state?: Maybe<Scalars['String']['output']>;
  address_zip?: Maybe<Scalars['String']['output']>;
  creation_time: Scalars['DateTime']['output'];
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  insured_status: Scalars['String']['output'];
  insured_type: SkypadInterestedPartyInsuredEnum;
  isCompany: Scalars['Boolean']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  last_update_by?: Maybe<Scalars['Int']['output']>;
  last_update_reason?: Maybe<Scalars['String']['output']>;
  last_update_time: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  policy_id: Scalars['Int']['output'];
  record_status: Scalars['String']['output'];
};

export enum SkypadInterestedPartyInsuredEnum {
  InterestedParty = 'INTERESTED_PARTY'
}

export type SkypadPaymentMethod = {
  __typename?: 'SkypadPaymentMethod';
  account_number: Scalars['String']['output'];
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address_city?: Maybe<Scalars['String']['output']>;
  address_country?: Maybe<Scalars['String']['output']>;
  address_state?: Maybe<Scalars['String']['output']>;
  address_zip?: Maybe<Scalars['String']['output']>;
  exp_month: Scalars['String']['output'];
  exp_year: Scalars['String']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last4?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  payment_method_brand?: Maybe<Scalars['String']['output']>;
  payment_method_status: Scalars['String']['output'];
  policies: Array<SkypadPolicy>;
  update_pending: Scalars['Boolean']['output'];
};

export type SkypadPaymentTransaction = {
  __typename?: 'SkypadPaymentTransaction';
  amount: Scalars['Float']['output'];
  charge_date?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  paymentMethod?: Maybe<SkypadPaymentMethod>;
  payment_status: SkypadPaymentTransactionPaymentStatus;
  policy?: Maybe<SkypadPolicy>;
  refund?: Maybe<SkypadCalculateRefund>;
  transaction_id: Scalars['String']['output'];
};

/** A paginated list of SkypadPaymentTransaction items. */
export type SkypadPaymentTransactionPaginator = {
  __typename?: 'SkypadPaymentTransactionPaginator';
  /** A list of SkypadPaymentTransaction items. */
  data: Array<SkypadPaymentTransaction>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum SkypadPaymentTransactionPaymentStatus {
  Failed = 'failed',
  Succeeded = 'succeeded'
}

export type SkypadPaymentsTransactionInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type SkypadPolicy = {
  __typename?: 'SkypadPolicy';
  account_id: Scalars['Int']['output'];
  adv_payment_interval: Scalars['Int']['output'];
  canFileClaim: Scalars['Boolean']['output'];
  canSuspend: Scalars['Boolean']['output'];
  cancellation_date?: Maybe<Scalars['DateTime']['output']>;
  cancellation_last_active_date?: Maybe<Scalars['Date']['output']>;
  cancellation_reason?: Maybe<Scalars['String']['output']>;
  cancellation_source?: Maybe<Scalars['String']['output']>;
  client_id?: Maybe<Scalars['Int']['output']>;
  coverage_end_date?: Maybe<Scalars['Date']['output']>;
  coverage_start_date: Scalars['Date']['output'];
  creation_time: Scalars['DateTime']['output'];
  deductible: Scalars['Int']['output'];
  documents?: Maybe<Array<PolicyDocumentsResponse>>;
  draft?: Maybe<SkypadPolicy>;
  draft_effective_date?: Maybe<Scalars['Date']['output']>;
  earthquake_coverage: Scalars['Int']['output'];
  edition_schedule?: Maybe<Scalars['String']['output']>;
  end_month_balance: Scalars['Int']['output'];
  enrollment_date?: Maybe<Scalars['DateTime']['output']>;
  /**  Relationships  */
  failedPaymentTransactions?: Maybe<Array<SkypadPaymentTransaction>>;
  fulfillment_datetime?: Maybe<Scalars['String']['output']>;
  hurricane_coverage?: Maybe<Scalars['Int']['output']>;
  hurricane_deductible: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  insured: SkypadInsured;
  interestedParty?: Maybe<SkypadInterestedPartyInsured>;
  isAutoRenew: Scalars['Boolean']['output'];
  isImported: Scalars['Boolean']['output'];
  isModifiable: Scalars['Boolean']['output'];
  isMonthly: Scalars['Boolean']['output'];
  lastPaymentFailed?: Maybe<SkypadPaymentTransaction>;
  last_update_by: Scalars['Int']['output'];
  last_update_reason?: Maybe<Scalars['String']['output']>;
  last_update_time: Scalars['DateTime']['output'];
  liability_coverage: Scalars['Int']['output'];
  medical_payment_to_others: Scalars['Int']['output'];
  neverCovered: Scalars['Boolean']['output'];
  next_pay_date?: Maybe<Scalars['Date']['output']>;
  payment_interval: Scalars['Int']['output'];
  payment_plan?: Maybe<Scalars['String']['output']>;
  payment_type?: Maybe<SkypadPolicyPaymentType>;
  policy_end_date?: Maybe<Scalars['Date']['output']>;
  policy_number: Scalars['String']['output'];
  policy_status: SkypadPolicyStatus;
  preferred: Scalars['Boolean']['output'];
  prev_policy_number?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  property_coverage: Scalars['Int']['output'];
  record_status: Scalars['String']['output'];
  roommates?: Maybe<Array<SkypadRoommateInsured>>;
  subscription_id?: Maybe<Scalars['String']['output']>;
  total_payments: Scalars['Int']['output'];
};

export enum SkypadPolicyPaymentType {
  Import = 'import',
  Stripe = 'stripe'
}

export enum SkypadPolicyStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Draft = 'draft',
  Expired = 'expired',
  Inactive = 'inactive',
  PermCancelled = 'permCancelled',
  PermSuspended = 'permSuspended',
  PreCancelled = 'preCancelled',
  Preactive = 'preactive',
  Predisbursement = 'predisbursement',
  Suspended = 'suspended',
  Unpaid = 'unpaid'
}

export enum SkypadPrimaryInsuredEnum {
  Primary = 'PRIMARY'
}

export type SkypadRefund = {
  __typename?: 'SkypadRefund';
  amount_refunded: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  refund_reason: Scalars['String']['output'];
  refund_status: Scalars['String']['output'];
  refund_time?: Maybe<Scalars['DateTime']['output']>;
};

/** SkypadInsured is the type "additional" only. */
export type SkypadRoommateInsured = {
  __typename?: 'SkypadRoommateInsured';
  creation_time: Scalars['DateTime']['output'];
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  insured_status: Scalars['String']['output'];
  insured_type: SkypadRoommateInsuredEnum;
  last_name: Scalars['String']['output'];
  last_update_by?: Maybe<Scalars['Int']['output']>;
  last_update_reason?: Maybe<Scalars['String']['output']>;
  last_update_time: Scalars['DateTime']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  policy_id: Scalars['Int']['output'];
  record_status: Scalars['String']['output'];
};

export enum SkypadRoommateInsuredEnum {
  Additional = 'ADDITIONAL'
}

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export enum SprinklerEnum {
  All = 'all',
  Limited = 'limited',
  None = 'none'
}

export enum TermTypesEnum {
  Annual = 'annual',
  Fall = 'fall',
  Jterm = 'jterm',
  May = 'may',
  Spring = 'spring',
  Summer = 'summer',
  Winter = 'winter'
}

export enum TransactionTypeEnum {
  Bml = 'BML',
  Nbs = 'NBS',
  Pch = 'PCH',
  Rei = 'REI',
  Rwl = 'RWL',
  Xlc = 'XLC'
}

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type TuitionPolicyCancelInput = {
  policyNumber: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type TuitionPolicyCancelResponse = {
  __typename?: 'TuitionPolicyCancelResponse';
  billing_system: Scalars['String']['output'];
  policy_end_date: Scalars['String']['output'];
  refund_amount: Scalars['Float']['output'];
  refund_status: Scalars['String']['output'];
};

export type TuitionQuote = {
  __typename?: 'TuitionQuote';
  products: Array<TuitionQuoteProduct>;
  ref_code: Scalars['String']['output'];
  school_name: Scalars['String']['output'];
};

export type TuitionQuoteProduct = {
  __typename?: 'TuitionQuoteProduct';
  features?: Maybe<TuitionQuoteProductFeatures>;
  offer: TuitionQuoteProductOffer;
  product_benefits_uri: Scalars['String']['output'];
  product_id: Scalars['String']['output'];
  product_name: Scalars['String']['output'];
  quote: TuitionQuoteProductQuote;
};

export type TuitionQuoteProductFeatures = {
  __typename?: 'TuitionQuoteProductFeatures';
  epidemic_endorsement: Scalars['String']['output'];
  existing_medical_coverage: Scalars['String']['output'];
  housing_expense_type: Scalars['String']['output'];
  mental_hospitalization_requirement: Scalars['String']['output'];
  other_school_expense_coverage: Scalars['String']['output'];
  other_school_expense_lol: Scalars['Int']['output'];
  reason_death_coverage: Scalars['String']['output'];
  reason_death_tp_coverage: Scalars['String']['output'];
  reason_illness_coverage: Scalars['String']['output'];
  reason_injury_coverage: Scalars['String']['output'];
  reason_mental_coverage: Scalars['String']['output'];
  reason_unemployment_tp_coverage: Scalars['String']['output'];
  reason_unforeseen_coverage: Scalars['String']['output'];
  student_life_assistance: Scalars['String']['output'];
};

export type TuitionQuoteProductOffer = {
  __typename?: 'TuitionQuoteProductOffer';
  offer_content?: Maybe<Scalars['String']['output']>;
  offer_content_elements?: Maybe<TuitionQuoteProductOfferElements>;
  offer_content_url?: Maybe<Scalars['String']['output']>;
  offer_id: Scalars['String']['output'];
};

export type TuitionQuoteProductOfferElements = {
  __typename?: 'TuitionQuoteProductOfferElements';
  body?: Maybe<Scalars['String']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TuitionQuoteProductQuote = {
  __typename?: 'TuitionQuoteProductQuote';
  coverage_amount: Scalars['Int']['output'];
  national_pricing: Scalars['Boolean']['output'];
  price: Scalars['Float']['output'];
  quote_country: Scalars['String']['output'];
  quote_id: Scalars['String']['output'];
  quote_region: Scalars['String']['output'];
  term_end: Scalars['Date']['output'];
  term_name: Scalars['String']['output'];
  term_start: Scalars['Date']['output'];
  term_type: Scalars['String']['output'];
};

export type TuitionQuoteTerm = {
  __typename?: 'TuitionQuoteTerm';
  quote?: Maybe<TuitionQuote>;
  refCodeTerm?: Maybe<RefCodeTerm>;
  term: TuitionQuoteTermParams;
};

export type TuitionQuoteTermParams = {
  __typename?: 'TuitionQuoteTermParams';
  coverage_amount: Scalars['Int']['output'];
  extension_date?: Maybe<Scalars['String']['output']>;
  offer_open_date?: Maybe<Scalars['String']['output']>;
  term_end: Scalars['String']['output'];
  term_name: Scalars['String']['output'];
  term_start: Scalars['String']['output'];
  term_type: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address_city?: Maybe<Scalars['String']['output']>;
  address_country?: Maybe<Scalars['String']['output']>;
  address_state?: Maybe<Scalars['String']['output']>;
  address_zip?: Maybe<Scalars['String']['output']>;
  contactPrimaryEmail?: Maybe<Contact>;
  contactPrimaryPhone?: Maybe<Contact>;
  contacts?: Maybe<Array<Contact>>;
  email: Scalars['String']['output'];
  /**  Relationships  */
  entities: Array<Entity>;
  first_name: Scalars['String']['output'];
  hasKamino?: Maybe<Scalars['Boolean']['output']>;
  hasKaminoPaymentMethod?: Maybe<Scalars['Boolean']['output']>;
  hasRenters?: Maybe<Scalars['Boolean']['output']>;
  hasSkypad?: Maybe<Scalars['Boolean']['output']>;
  hasSkypadPaymentMethod?: Maybe<Scalars['Boolean']['output']>;
  hasTuition?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  kaminoValidPolicies: Array<KaminoPolicy>;
  last_name: Scalars['String']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phone_country_id?: Maybe<Scalars['Int']['output']>;
  preferred_name?: Maybe<Scalars['String']['output']>;
  /**  Custom Fields  */
  requiresMfa?: Maybe<Scalars['Boolean']['output']>;
  sameAsEntity?: Maybe<Scalars['String']['output']>;
  sessionImpersonation?: Maybe<Scalars['Boolean']['output']>;
  sms_phone?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type PolicyDocumentsResponse = {
  __typename?: 'policyDocumentsResponse';
  document_path?: Maybe<Scalars['String']['output']>;
  document_title?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type CancelRentersMembershipResponseFragmentFragment = { __typename?: 'CancelRentersMembershipResponse', monthsRefunded: number, refundAmount: number, paymentsRemaining: number, coverageEndDate: string, policyEndDate: string, flatCancel: boolean, prorationRefunds: Array<string | null>, isRefunded: boolean };

export type CalculateRentersCancelResponseFragmentFragment = { __typename?: 'CalculateRentersCancelResponse', monthsRefunded: number, refundAmount: number, paymentsRemaining: number, coverageEndDate: string, policyEndDate: string, flatCancel: boolean, lastActiveDate: string };

export type CalculateRentersUpdateResponseFragmentFragment = { __typename?: 'CalculateRentersUpdateResponse', operation: CalculateRentersUpdateOperationEnum, previous_policy?: { __typename?: 'CalculcateRentersUpdatePreviousPolicy', coverage_end_date: string, flat_cancel: boolean, months_refunded: number, payments_remaining: number, policy_end_date: string, refund_amount: number } | null, prorated?: { __typename?: 'CalculateRentersUpdateProrated', new_price: number, original_price: number, price: number } | null, next_policy?: { __typename?: 'CalculateRentersUpdateNextPolicy', amount_due: number, coverage_start_date?: string | null, next_pay_date?: string | null } | null };

export type ContactFragmentFragment = { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any };

export type FaberInsuredFragmentFragment = { __typename?: 'FaberInsured', id: number, client_id: number, external_insured_id: number, external_insured_cd: string, policy_id: number, school_id: number, first_name: string, last_name: string, email: string, phone: string, dob: any, years_in_school: number, address1: string, address2: string, address_city: string, address_state: string, address_zip: string, address_country: string, insured_status: string, creation_time: any, last_updated_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string };

export type FaberPaymentMethodFragmentFragment = { __typename?: 'FaberPaymentMethod', id: number, first_name: string, last_name: string, address1: string, address2: string, address_city: string, address_state: string, address_zip: string, address_country: string, payment_method_brand: string, exp_month: string, exp_year: string, payment_method_status: FaberPaymentMethodStatus, last4: string };

export type FaberPaymentTransactionFragmentFragment = { __typename?: 'FaberPaymentTransaction', id: number, external_transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: FaberPaymentTransactionPaymentStatus, paymentMethod: { __typename?: 'FaberPaymentMethod', id: number, first_name: string, last_name: string, address1: string, address2: string, address_city: string, address_state: string, address_zip: string, address_country: string, payment_method_brand: string, exp_month: string, exp_year: string, payment_method_status: FaberPaymentMethodStatus, last4: string }, policy?: { __typename?: 'FaberPolicy', id: number, policy_number: string } | null };

export type FaberPolicyFragmentFragment = { __typename?: 'FaberPolicy', id: number, client_id: number, product_id: string, account_id: number, quote_response_id: number, payment_transaction_id?: number | null, price: number, policy_number: string, prev_policy_number?: string | null, start_date: string, end_date: string, coverage_amount?: number | null, term_name?: string | null, fulfillment_time?: string | null, cancellation_received?: string | null, cancellation_date?: string | null, cancellation_reason?: string | null, cancellation_source?: string | null, admin_system: string, policy_status: FaberPolicyStatus, isImported: boolean, canFileClaim: boolean, creation_time?: string | null, neverCovered: boolean, showCancel: boolean, school: { __typename?: 'School', id: number, school_name: string }, insured: { __typename?: 'FaberInsured', id: number, client_id: number, external_insured_id: number, external_insured_cd: string, policy_id: number, school_id: number, first_name: string, last_name: string, email: string, phone: string, dob: any, years_in_school: number, address1: string, address2: string, address_city: string, address_state: string, address_zip: string, address_country: string, insured_status: string, creation_time: any, last_updated_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string }, lastPaymentFailed?: { __typename?: 'FaberPaymentTransaction', id: number, external_transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: FaberPaymentTransactionPaymentStatus, paymentMethod: { __typename?: 'FaberPaymentMethod', id: number, first_name: string, last_name: string, address1: string, address2: string, address_city: string, address_state: string, address_zip: string, address_country: string, payment_method_brand: string, exp_month: string, exp_year: string, payment_method_status: FaberPaymentMethodStatus, last4: string }, policy?: { __typename?: 'FaberPolicy', id: number, policy_number: string } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null };

export type FaberQuoteResponseFragmentFragment = { __typename?: 'FaberQuoteResponse', id: number, allianz_quote_id: string, external_student_id?: string | null, quote_transaction_id?: string | null, session_id?: string | null, school_id: number, client_id: number, product_id: string, offer_id: number, cxid?: number | null, response_id?: number | null, region: string, coverage_amount: number, term_start: any, term_end: any, price: number, study_abroad: string, offer_language: string, term_name?: string | null, term_type?: string | null, quote_response_status?: string | null, creation_time: any, last_updated_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string };

export type MembershipFragmentFragment = { __typename?: 'Membership', id: number, entity_id: number, user_id: number, orig_plan_id: number, orig_sku_id?: number | null, policy_number?: string | null, prev_policy_number?: string | null, payment_method_id: number, membership_group_id: number, program_season: string, program_term?: string | null, num_spouses: number, num_dependents: number, max_benefit: number, insurance_type?: string | null, product_type?: string | null, deductible?: number | null, payment_interval: number, adv_payment_interval: number, total_payments: number, payments_remaining: number, fail_count: number, end_month_balance: number, enrollment_date?: string | null, start_date?: string | null, next_pay_date?: string | null, auto_renew: string, client_id?: number | null, agent_id?: number | null, dtd_code?: string | null, coverage_start_date?: string | null, coverage_end_date?: string | null, covered_terms?: string | null, loss_payee?: string | null, state?: string | null, admin_system?: string | null, membership_source: string, membership_status: string, creation_time?: string | null, last_update_time?: string | null, last_update_by?: number | null, last_update_by_type?: string | null, created_by?: number | null, created_by_type?: string | null, last_update_reason?: string | null, record_status: string, entity: { __typename?: 'Entity', id: number, first_name: string, last_name: string } };

export type MessageResponseFragmentFragment = { __typename?: 'MessageResponse', message: string, type: MessageResponseType };

type MmaSessionFragment_Entity_Fragment = { __typename: 'Entity', id: number, uuid: string, school_id?: number | null, school: string, first_name: string, preferred_name?: string | null, middle_name?: string | null, last_name: string, dob?: string | null, requiresMfa?: boolean | null, sms_phone?: string | null, sessionImpersonation?: boolean | null, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country?: string | null, hasRenters?: boolean | null, hasKamino?: boolean | null, hasSkypad?: boolean | null, hasTuition?: boolean | null, showRentersCrossSell?: boolean | null, showTuitionCrossSell?: boolean | null, entity_email?: string | null, contactPrimaryPhone?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null, contactPrimaryEmail?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null };

type MmaSessionFragment_User_Fragment = { __typename: 'User', id: number, username?: string | null, first_name: string, preferred_name?: string | null, middle_name?: string | null, last_name: string, requiresMfa?: boolean | null, sms_phone?: string | null, sessionImpersonation?: boolean | null, hasRenters?: boolean | null, hasTuition?: boolean | null, hasKamino?: boolean | null, hasKaminoPaymentMethod?: boolean | null, hasSkypadPaymentMethod?: boolean | null, hasSkypad?: boolean | null, sameAsEntity?: string | null, user_email: string, user_address1?: string | null, user_address2?: string | null, user_address_city?: string | null, user_address_state?: string | null, user_address_zip?: string | null, user_address_country?: string | null, contactPrimaryPhone?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null, contactPrimaryEmail?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null, entities: Array<{ __typename?: 'Entity', id: number, uuid: string, first_name: string, last_name: string }>, kaminoValidPolicies: Array<{ __typename?: 'KaminoPolicy', uuid: string, policyNumber: string }> };

export type MmaSessionFragmentFragment =
  | MmaSessionFragment_Entity_Fragment
  | MmaSessionFragment_User_Fragment
;

export type PolicyCardMembershipFragmentFragment = { __typename?: 'PolicyCardMembership', policy_number: string, coverage_start_date: string, coverage_end_date: string, membership_status: string, membership_source: string, insurance_type: string, user_id: number, entity_id: number, next_pay_date: string, first_name: string, last_name: string, mma_status_box: string };

export type PolicyDocumentsResponseFragmentFragment = { __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null };

export type PropertyFragmentFragment = { __typename?: 'Property', id: number, property_name?: string | null, external_id?: string | null, school_id?: number | null, address1?: string | null, address2: string, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country: string, property_status: string };

export type RefCodeTermFragmentFragment = { __typename?: 'RefCodeTerm', id: number, uuid?: string | null, term_name: string, term_start?: any | null, term_end?: any | null, offer_open_date?: any | null, extension_date?: any | null, term_type?: TermTypesEnum | null, min_coverage: number, default_coverage: number, daysRemaining?: number | null };

export type SchoolFragmentFragment = { __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean };

export type SkypadInsuredFragmentFragment = { __typename?: 'SkypadInsured', id: number, policy_id: number, external_id: string, external_cd: string, insured_type: SkypadPrimaryInsuredEnum, first_name: string, last_name: string, email: string, phone?: string | null, dob?: string | null, property_owner: string, property_name: string, property_external_id?: string | null, property_external_cd?: string | null, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string, allowEarthquake: boolean, isOnCampus: boolean, school?: { __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean } | null, property?: { __typename?: 'Property', id: number, property_name?: string | null, external_id?: string | null, school_id?: number | null, address1?: string | null, address2: string, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country: string, property_status: string } | null };

export type SkypadRoommateInsuredFragmentFragment = { __typename?: 'SkypadRoommateInsured', id: number, policy_id: number, insured_type: SkypadRoommateInsuredEnum, first_name: string, last_name: string, email?: string | null, phone?: string | null, dob?: string | null, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string };

export type SkypadInterestedPartyInsuredFragmentFragment = { __typename?: 'SkypadInterestedPartyInsured', id: number, policy_id: number, insured_type: SkypadInterestedPartyInsuredEnum, first_name: string, last_name?: string | null, name: string, isCompany: boolean, email?: string | null, phone?: string | null, dob?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string };

export type SkypadPaymentMethodFragmentFragment = { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> };

export type SkypadPaymentTransactionFragmentFragment = { __typename?: 'SkypadPaymentTransaction', id: number, transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: SkypadPaymentTransactionPaymentStatus, paymentMethod?: { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> } | null, policy?: { __typename?: 'SkypadPolicy', id: number, policy_number: string } | null };

export type SkypadPolicyBaseFragmentFragment = { __typename?: 'SkypadPolicy', id: number, client_id?: number | null, account_id: number, policy_number: string, prev_policy_number?: string | null, subscription_id?: string | null, price: number, property_coverage: number, liability_coverage: number, earthquake_coverage: number, hurricane_coverage?: number | null, hurricane_deductible: number, deductible: number, medical_payment_to_others: number, payment_interval: number, adv_payment_interval: number, total_payments: number, end_month_balance: number, edition_schedule?: string | null, payment_plan?: string | null, payment_type?: SkypadPolicyPaymentType | null, enrollment_date?: any | null, cancellation_date?: any | null, cancellation_last_active_date?: any | null, cancellation_reason?: string | null, cancellation_source?: string | null, coverage_start_date: any, coverage_end_date?: any | null, policy_end_date?: any | null, draft_effective_date?: any | null, next_pay_date?: any | null, fulfillment_datetime?: string | null, policy_status: SkypadPolicyStatus, creation_time: any, last_update_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, isImported: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, preferred: boolean };

export type SkypadPolicyFragmentFragment = { __typename?: 'SkypadPolicy', id: number, client_id?: number | null, account_id: number, policy_number: string, prev_policy_number?: string | null, subscription_id?: string | null, price: number, property_coverage: number, liability_coverage: number, earthquake_coverage: number, hurricane_coverage?: number | null, hurricane_deductible: number, deductible: number, medical_payment_to_others: number, payment_interval: number, adv_payment_interval: number, total_payments: number, end_month_balance: number, edition_schedule?: string | null, payment_plan?: string | null, payment_type?: SkypadPolicyPaymentType | null, enrollment_date?: any | null, cancellation_date?: any | null, cancellation_last_active_date?: any | null, cancellation_reason?: string | null, cancellation_source?: string | null, coverage_start_date: any, coverage_end_date?: any | null, policy_end_date?: any | null, draft_effective_date?: any | null, next_pay_date?: any | null, fulfillment_datetime?: string | null, policy_status: SkypadPolicyStatus, creation_time: any, last_update_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, isImported: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, preferred: boolean, failedPaymentTransactions?: Array<{ __typename?: 'SkypadPaymentTransaction', id: number, transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: SkypadPaymentTransactionPaymentStatus, paymentMethod?: { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> } | null, policy?: { __typename?: 'SkypadPolicy', id: number, policy_number: string } | null }> | null, insured: { __typename?: 'SkypadInsured', id: number, policy_id: number, external_id: string, external_cd: string, insured_type: SkypadPrimaryInsuredEnum, first_name: string, last_name: string, email: string, phone?: string | null, dob?: string | null, property_owner: string, property_name: string, property_external_id?: string | null, property_external_cd?: string | null, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string, allowEarthquake: boolean, isOnCampus: boolean, school?: { __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean } | null, property?: { __typename?: 'Property', id: number, property_name?: string | null, external_id?: string | null, school_id?: number | null, address1?: string | null, address2: string, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country: string, property_status: string } | null }, roommates?: Array<{ __typename?: 'SkypadRoommateInsured', id: number, policy_id: number, insured_type: SkypadRoommateInsuredEnum, first_name: string, last_name: string, email?: string | null, phone?: string | null, dob?: string | null, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string }> | null, interestedParty?: { __typename?: 'SkypadInterestedPartyInsured', id: number, policy_id: number, insured_type: SkypadInterestedPartyInsuredEnum, first_name: string, last_name?: string | null, name: string, isCompany: boolean, email?: string | null, phone?: string | null, dob?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string } | null, draft?: { __typename?: 'SkypadPolicy', id: number, client_id?: number | null, account_id: number, policy_number: string, prev_policy_number?: string | null, subscription_id?: string | null, price: number, property_coverage: number, liability_coverage: number, earthquake_coverage: number, hurricane_coverage?: number | null, hurricane_deductible: number, deductible: number, medical_payment_to_others: number, payment_interval: number, adv_payment_interval: number, total_payments: number, end_month_balance: number, edition_schedule?: string | null, payment_plan?: string | null, payment_type?: SkypadPolicyPaymentType | null, enrollment_date?: any | null, cancellation_date?: any | null, cancellation_last_active_date?: any | null, cancellation_reason?: string | null, cancellation_source?: string | null, coverage_start_date: any, coverage_end_date?: any | null, policy_end_date?: any | null, draft_effective_date?: any | null, next_pay_date?: any | null, fulfillment_datetime?: string | null, policy_status: SkypadPolicyStatus, creation_time: any, last_update_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, isImported: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, preferred: boolean } | null, lastPaymentFailed?: { __typename?: 'SkypadPaymentTransaction', id: number, transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: SkypadPaymentTransactionPaymentStatus, paymentMethod?: { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> } | null, policy?: { __typename?: 'SkypadPolicy', id: number, policy_number: string } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null };

export type TuitionQuoteFragmentFragment = { __typename?: 'TuitionQuote', products: Array<{ __typename?: 'TuitionQuoteProduct', product_id: string, product_name: string, product_benefits_uri: string, quote: { __typename?: 'TuitionQuoteProductQuote', quote_id: string, quote_country: string, quote_region: string, coverage_amount: number, price: number, national_pricing: boolean, term_start: any, term_end: any, term_name: string, term_type: string }, offer: { __typename?: 'TuitionQuoteProductOffer', offer_id: string, offer_content?: string | null, offer_content_url?: string | null, offer_content_elements?: { __typename?: 'TuitionQuoteProductOfferElements', title?: string | null, subtitle?: string | null, body?: string | null, footer?: string | null } | null }, features?: { __typename?: 'TuitionQuoteProductFeatures', existing_medical_coverage: string, housing_expense_type: string, other_school_expense_coverage: string, other_school_expense_lol: number, student_life_assistance: string, reason_illness_coverage: string, reason_injury_coverage: string, reason_death_coverage: string, reason_mental_coverage: string, reason_death_tp_coverage: string, reason_unemployment_tp_coverage: string, reason_unforeseen_coverage: string, mental_hospitalization_requirement: string, epidemic_endorsement: string } | null }> };

export type UserFragmentFragment = { __typename: 'User', id: number, username?: string | null, first_name: string, preferred_name?: string | null, middle_name?: string | null, last_name: string, requiresMfa?: boolean | null, sms_phone?: string | null, sessionImpersonation?: boolean | null, hasRenters?: boolean | null, hasTuition?: boolean | null, hasKamino?: boolean | null, hasKaminoPaymentMethod?: boolean | null, hasSkypadPaymentMethod?: boolean | null, hasSkypad?: boolean | null, sameAsEntity?: string | null, user_email: string, user_address1?: string | null, user_address2?: string | null, user_address_city?: string | null, user_address_state?: string | null, user_address_zip?: string | null, user_address_country?: string | null, contactPrimaryPhone?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null, contactPrimaryEmail?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null, entities: Array<{ __typename?: 'Entity', id: number, uuid: string, first_name: string, last_name: string }>, kaminoValidPolicies: Array<{ __typename?: 'KaminoPolicy', uuid: string, policyNumber: string }> };

export type EntitySessionFragmentFragment = { __typename: 'Entity', id: number, uuid: string, school_id?: number | null, school: string, first_name: string, preferred_name?: string | null, middle_name?: string | null, last_name: string, dob?: string | null, requiresMfa?: boolean | null, sms_phone?: string | null, sessionImpersonation?: boolean | null, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country?: string | null, hasRenters?: boolean | null, hasKamino?: boolean | null, hasSkypad?: boolean | null, hasTuition?: boolean | null, showRentersCrossSell?: boolean | null, showTuitionCrossSell?: boolean | null, entity_email?: string | null, contactPrimaryPhone?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null, contactPrimaryEmail?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null };

export type LastRentersPolicyFragmentFragment = { __typename?: 'LastRentersPolicy', skypad?: { __typename?: 'SkypadPolicy', id: number, client_id?: number | null, account_id: number, policy_number: string, prev_policy_number?: string | null, subscription_id?: string | null, price: number, property_coverage: number, liability_coverage: number, earthquake_coverage: number, hurricane_coverage?: number | null, hurricane_deductible: number, deductible: number, medical_payment_to_others: number, payment_interval: number, adv_payment_interval: number, total_payments: number, end_month_balance: number, edition_schedule?: string | null, payment_plan?: string | null, payment_type?: SkypadPolicyPaymentType | null, enrollment_date?: any | null, cancellation_date?: any | null, cancellation_last_active_date?: any | null, cancellation_reason?: string | null, cancellation_source?: string | null, coverage_start_date: any, coverage_end_date?: any | null, policy_end_date?: any | null, draft_effective_date?: any | null, next_pay_date?: any | null, fulfillment_datetime?: string | null, policy_status: SkypadPolicyStatus, creation_time: any, last_update_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, isImported: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, preferred: boolean, failedPaymentTransactions?: Array<{ __typename?: 'SkypadPaymentTransaction', id: number, transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: SkypadPaymentTransactionPaymentStatus, paymentMethod?: { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> } | null, policy?: { __typename?: 'SkypadPolicy', id: number, policy_number: string } | null }> | null, insured: { __typename?: 'SkypadInsured', id: number, policy_id: number, external_id: string, external_cd: string, insured_type: SkypadPrimaryInsuredEnum, first_name: string, last_name: string, email: string, phone?: string | null, dob?: string | null, property_owner: string, property_name: string, property_external_id?: string | null, property_external_cd?: string | null, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string, allowEarthquake: boolean, isOnCampus: boolean, school?: { __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean } | null, property?: { __typename?: 'Property', id: number, property_name?: string | null, external_id?: string | null, school_id?: number | null, address1?: string | null, address2: string, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country: string, property_status: string } | null }, roommates?: Array<{ __typename?: 'SkypadRoommateInsured', id: number, policy_id: number, insured_type: SkypadRoommateInsuredEnum, first_name: string, last_name: string, email?: string | null, phone?: string | null, dob?: string | null, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string }> | null, interestedParty?: { __typename?: 'SkypadInterestedPartyInsured', id: number, policy_id: number, insured_type: SkypadInterestedPartyInsuredEnum, first_name: string, last_name?: string | null, name: string, isCompany: boolean, email?: string | null, phone?: string | null, dob?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string } | null, draft?: { __typename?: 'SkypadPolicy', id: number, client_id?: number | null, account_id: number, policy_number: string, prev_policy_number?: string | null, subscription_id?: string | null, price: number, property_coverage: number, liability_coverage: number, earthquake_coverage: number, hurricane_coverage?: number | null, hurricane_deductible: number, deductible: number, medical_payment_to_others: number, payment_interval: number, adv_payment_interval: number, total_payments: number, end_month_balance: number, edition_schedule?: string | null, payment_plan?: string | null, payment_type?: SkypadPolicyPaymentType | null, enrollment_date?: any | null, cancellation_date?: any | null, cancellation_last_active_date?: any | null, cancellation_reason?: string | null, cancellation_source?: string | null, coverage_start_date: any, coverage_end_date?: any | null, policy_end_date?: any | null, draft_effective_date?: any | null, next_pay_date?: any | null, fulfillment_datetime?: string | null, policy_status: SkypadPolicyStatus, creation_time: any, last_update_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, isImported: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, preferred: boolean } | null, lastPaymentFailed?: { __typename?: 'SkypadPaymentTransaction', id: number, transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: SkypadPaymentTransactionPaymentStatus, paymentMethod?: { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> } | null, policy?: { __typename?: 'SkypadPolicy', id: number, policy_number: string } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null } | null, kamino?: { __typename?: 'KaminoPolicy', uuid: string, kamino_account_holder_uuid: string, policy_number?: string | null, confirmation_number: string, previous_policy_number?: string | null, enrollment_date?: any | null, policy_start_date: any, policy_end_date?: any | null, policy_status: KaminoPolicyStatus, payment_interval: number, is_auto_renew: boolean, created_at?: any | null, updated_at?: any | null, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, policyNumber: string, details: { __typename?: 'KaminoPolicyDetails', subscription_price: number, next_amount_due: number, coverages: { __typename?: 'KaminoPolicyCoverages', price: number, property_limit: number, deductible: number, liability_limit: number, earthquake_limit: number, scheduled_property_limit: number, bedbug_limit: number } }, lastPolicyTransaction: { __typename?: 'KaminoPolicyTransaction', uuid: string, kamino_policy_uuid: string, kamino_transaction_type: TransactionTypeEnum, transaction_initiated_datetime: any, transaction_effective_datetime: any, next_pay_date?: string | null, kamino_insureds_uuid: string, kamino_coverage_uuid: string, kamino_subscription_uuid?: string | null, kamino_payment_transaction_uuid?: string | null, created_at?: any | null, updated_at?: any | null, insured: { __typename?: 'KaminoInsureds', uuid: string, kamino_address_uuid: string, effective_date: any, is_preferred: number, is_on_campus: number, property_external_id: number, property_external_cd: string, created_at?: any | null, updated_at?: any | null, address: { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null }, primaryInsured: { __typename?: 'KaminoInsuredPerson', uuid: string, kamino_insureds_uuid: string, kamino_person_uuid: string, person_type: KaminoPersonType, core_entity_id?: number | null, created_at?: any | null, updated_at?: any | null, person: { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null } }, additionalInsureds: Array<{ __typename?: 'KaminoInsuredPerson', uuid: string, kamino_insureds_uuid: string, kamino_person_uuid: string, person_type: KaminoPersonType, core_entity_id?: number | null, created_at?: any | null, updated_at?: any | null, person: { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null } }>, school: { __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean } } }, interestedParty?: { __typename?: 'KaminoInterestedParty', uuid: string, name: string, email: string, phone?: string | null, phone_country_id?: string | null, type: InterestedPartyTypeEnum, effective_date?: string | null, expiration_date?: string | null, address?: { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null } | null };

export type EntityFragmentFragment = { __typename: 'Entity', id: number, uuid: string, school_id?: number | null, school: string, first_name: string, preferred_name?: string | null, middle_name?: string | null, last_name: string, dob?: string | null, requiresMfa?: boolean | null, sms_phone?: string | null, sessionImpersonation?: boolean | null, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country?: string | null, hasRenters?: boolean | null, hasKamino?: boolean | null, hasSkypad?: boolean | null, hasTuition?: boolean | null, showRentersCrossSell?: boolean | null, showTuitionCrossSell?: boolean | null, entity_email?: string | null, skypadPolicies?: Array<{ __typename?: 'SkypadPolicy', id: number, client_id?: number | null, account_id: number, policy_number: string, prev_policy_number?: string | null, subscription_id?: string | null, price: number, property_coverage: number, liability_coverage: number, earthquake_coverage: number, hurricane_coverage?: number | null, hurricane_deductible: number, deductible: number, medical_payment_to_others: number, payment_interval: number, adv_payment_interval: number, total_payments: number, end_month_balance: number, edition_schedule?: string | null, payment_plan?: string | null, payment_type?: SkypadPolicyPaymentType | null, enrollment_date?: any | null, cancellation_date?: any | null, cancellation_last_active_date?: any | null, cancellation_reason?: string | null, cancellation_source?: string | null, coverage_start_date: any, coverage_end_date?: any | null, policy_end_date?: any | null, draft_effective_date?: any | null, next_pay_date?: any | null, fulfillment_datetime?: string | null, policy_status: SkypadPolicyStatus, creation_time: any, last_update_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, isImported: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, preferred: boolean, failedPaymentTransactions?: Array<{ __typename?: 'SkypadPaymentTransaction', id: number, transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: SkypadPaymentTransactionPaymentStatus, paymentMethod?: { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> } | null, policy?: { __typename?: 'SkypadPolicy', id: number, policy_number: string } | null }> | null, insured: { __typename?: 'SkypadInsured', id: number, policy_id: number, external_id: string, external_cd: string, insured_type: SkypadPrimaryInsuredEnum, first_name: string, last_name: string, email: string, phone?: string | null, dob?: string | null, property_owner: string, property_name: string, property_external_id?: string | null, property_external_cd?: string | null, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string, allowEarthquake: boolean, isOnCampus: boolean, school?: { __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean } | null, property?: { __typename?: 'Property', id: number, property_name?: string | null, external_id?: string | null, school_id?: number | null, address1?: string | null, address2: string, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country: string, property_status: string } | null }, roommates?: Array<{ __typename?: 'SkypadRoommateInsured', id: number, policy_id: number, insured_type: SkypadRoommateInsuredEnum, first_name: string, last_name: string, email?: string | null, phone?: string | null, dob?: string | null, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string }> | null, interestedParty?: { __typename?: 'SkypadInterestedPartyInsured', id: number, policy_id: number, insured_type: SkypadInterestedPartyInsuredEnum, first_name: string, last_name?: string | null, name: string, isCompany: boolean, email?: string | null, phone?: string | null, dob?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string } | null, draft?: { __typename?: 'SkypadPolicy', id: number, client_id?: number | null, account_id: number, policy_number: string, prev_policy_number?: string | null, subscription_id?: string | null, price: number, property_coverage: number, liability_coverage: number, earthquake_coverage: number, hurricane_coverage?: number | null, hurricane_deductible: number, deductible: number, medical_payment_to_others: number, payment_interval: number, adv_payment_interval: number, total_payments: number, end_month_balance: number, edition_schedule?: string | null, payment_plan?: string | null, payment_type?: SkypadPolicyPaymentType | null, enrollment_date?: any | null, cancellation_date?: any | null, cancellation_last_active_date?: any | null, cancellation_reason?: string | null, cancellation_source?: string | null, coverage_start_date: any, coverage_end_date?: any | null, policy_end_date?: any | null, draft_effective_date?: any | null, next_pay_date?: any | null, fulfillment_datetime?: string | null, policy_status: SkypadPolicyStatus, creation_time: any, last_update_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, isImported: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, preferred: boolean } | null, lastPaymentFailed?: { __typename?: 'SkypadPaymentTransaction', id: number, transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: SkypadPaymentTransactionPaymentStatus, paymentMethod?: { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> } | null, policy?: { __typename?: 'SkypadPolicy', id: number, policy_number: string } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null }> | null, faberPolicies?: Array<{ __typename?: 'FaberPolicy', id: number, client_id: number, product_id: string, account_id: number, quote_response_id: number, payment_transaction_id?: number | null, price: number, policy_number: string, prev_policy_number?: string | null, start_date: string, end_date: string, coverage_amount?: number | null, term_name?: string | null, fulfillment_time?: string | null, cancellation_received?: string | null, cancellation_date?: string | null, cancellation_reason?: string | null, cancellation_source?: string | null, admin_system: string, policy_status: FaberPolicyStatus, isImported: boolean, canFileClaim: boolean, creation_time?: string | null, neverCovered: boolean, showCancel: boolean, school: { __typename?: 'School', id: number, school_name: string }, insured: { __typename?: 'FaberInsured', id: number, client_id: number, external_insured_id: number, external_insured_cd: string, policy_id: number, school_id: number, first_name: string, last_name: string, email: string, phone: string, dob: any, years_in_school: number, address1: string, address2: string, address_city: string, address_state: string, address_zip: string, address_country: string, insured_status: string, creation_time: any, last_updated_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string }, lastPaymentFailed?: { __typename?: 'FaberPaymentTransaction', id: number, external_transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: FaberPaymentTransactionPaymentStatus, paymentMethod: { __typename?: 'FaberPaymentMethod', id: number, first_name: string, last_name: string, address1: string, address2: string, address_city: string, address_state: string, address_zip: string, address_country: string, payment_method_brand: string, exp_month: string, exp_year: string, payment_method_status: FaberPaymentMethodStatus, last4: string }, policy?: { __typename?: 'FaberPolicy', id: number, policy_number: string } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null }> | null, lastRentersPolicy?: { __typename?: 'LastRentersPolicy', skypad?: { __typename?: 'SkypadPolicy', id: number, client_id?: number | null, account_id: number, policy_number: string, prev_policy_number?: string | null, subscription_id?: string | null, price: number, property_coverage: number, liability_coverage: number, earthquake_coverage: number, hurricane_coverage?: number | null, hurricane_deductible: number, deductible: number, medical_payment_to_others: number, payment_interval: number, adv_payment_interval: number, total_payments: number, end_month_balance: number, edition_schedule?: string | null, payment_plan?: string | null, payment_type?: SkypadPolicyPaymentType | null, enrollment_date?: any | null, cancellation_date?: any | null, cancellation_last_active_date?: any | null, cancellation_reason?: string | null, cancellation_source?: string | null, coverage_start_date: any, coverage_end_date?: any | null, policy_end_date?: any | null, draft_effective_date?: any | null, next_pay_date?: any | null, fulfillment_datetime?: string | null, policy_status: SkypadPolicyStatus, creation_time: any, last_update_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, isImported: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, preferred: boolean, failedPaymentTransactions?: Array<{ __typename?: 'SkypadPaymentTransaction', id: number, transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: SkypadPaymentTransactionPaymentStatus, paymentMethod?: { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> } | null, policy?: { __typename?: 'SkypadPolicy', id: number, policy_number: string } | null }> | null, insured: { __typename?: 'SkypadInsured', id: number, policy_id: number, external_id: string, external_cd: string, insured_type: SkypadPrimaryInsuredEnum, first_name: string, last_name: string, email: string, phone?: string | null, dob?: string | null, property_owner: string, property_name: string, property_external_id?: string | null, property_external_cd?: string | null, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string, allowEarthquake: boolean, isOnCampus: boolean, school?: { __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean } | null, property?: { __typename?: 'Property', id: number, property_name?: string | null, external_id?: string | null, school_id?: number | null, address1?: string | null, address2: string, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country: string, property_status: string } | null }, roommates?: Array<{ __typename?: 'SkypadRoommateInsured', id: number, policy_id: number, insured_type: SkypadRoommateInsuredEnum, first_name: string, last_name: string, email?: string | null, phone?: string | null, dob?: string | null, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string }> | null, interestedParty?: { __typename?: 'SkypadInterestedPartyInsured', id: number, policy_id: number, insured_type: SkypadInterestedPartyInsuredEnum, first_name: string, last_name?: string | null, name: string, isCompany: boolean, email?: string | null, phone?: string | null, dob?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string } | null, draft?: { __typename?: 'SkypadPolicy', id: number, client_id?: number | null, account_id: number, policy_number: string, prev_policy_number?: string | null, subscription_id?: string | null, price: number, property_coverage: number, liability_coverage: number, earthquake_coverage: number, hurricane_coverage?: number | null, hurricane_deductible: number, deductible: number, medical_payment_to_others: number, payment_interval: number, adv_payment_interval: number, total_payments: number, end_month_balance: number, edition_schedule?: string | null, payment_plan?: string | null, payment_type?: SkypadPolicyPaymentType | null, enrollment_date?: any | null, cancellation_date?: any | null, cancellation_last_active_date?: any | null, cancellation_reason?: string | null, cancellation_source?: string | null, coverage_start_date: any, coverage_end_date?: any | null, policy_end_date?: any | null, draft_effective_date?: any | null, next_pay_date?: any | null, fulfillment_datetime?: string | null, policy_status: SkypadPolicyStatus, creation_time: any, last_update_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, isImported: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, preferred: boolean } | null, lastPaymentFailed?: { __typename?: 'SkypadPaymentTransaction', id: number, transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: SkypadPaymentTransactionPaymentStatus, paymentMethod?: { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> } | null, policy?: { __typename?: 'SkypadPolicy', id: number, policy_number: string } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null } | null, kamino?: { __typename?: 'KaminoPolicy', uuid: string, kamino_account_holder_uuid: string, policy_number?: string | null, confirmation_number: string, previous_policy_number?: string | null, enrollment_date?: any | null, policy_start_date: any, policy_end_date?: any | null, policy_status: KaminoPolicyStatus, payment_interval: number, is_auto_renew: boolean, created_at?: any | null, updated_at?: any | null, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, policyNumber: string, details: { __typename?: 'KaminoPolicyDetails', subscription_price: number, next_amount_due: number, coverages: { __typename?: 'KaminoPolicyCoverages', price: number, property_limit: number, deductible: number, liability_limit: number, earthquake_limit: number, scheduled_property_limit: number, bedbug_limit: number } }, lastPolicyTransaction: { __typename?: 'KaminoPolicyTransaction', uuid: string, kamino_policy_uuid: string, kamino_transaction_type: TransactionTypeEnum, transaction_initiated_datetime: any, transaction_effective_datetime: any, next_pay_date?: string | null, kamino_insureds_uuid: string, kamino_coverage_uuid: string, kamino_subscription_uuid?: string | null, kamino_payment_transaction_uuid?: string | null, created_at?: any | null, updated_at?: any | null, insured: { __typename?: 'KaminoInsureds', uuid: string, kamino_address_uuid: string, effective_date: any, is_preferred: number, is_on_campus: number, property_external_id: number, property_external_cd: string, created_at?: any | null, updated_at?: any | null, address: { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null }, primaryInsured: { __typename?: 'KaminoInsuredPerson', uuid: string, kamino_insureds_uuid: string, kamino_person_uuid: string, person_type: KaminoPersonType, core_entity_id?: number | null, created_at?: any | null, updated_at?: any | null, person: { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null } }, additionalInsureds: Array<{ __typename?: 'KaminoInsuredPerson', uuid: string, kamino_insureds_uuid: string, kamino_person_uuid: string, person_type: KaminoPersonType, core_entity_id?: number | null, created_at?: any | null, updated_at?: any | null, person: { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null } }>, school: { __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean } } }, interestedParty?: { __typename?: 'KaminoInterestedParty', uuid: string, name: string, email: string, phone?: string | null, phone_country_id?: string | null, type: InterestedPartyTypeEnum, effective_date?: string | null, expiration_date?: string | null, address?: { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null } | null } | null, lastTuitionPolicy?: { __typename?: 'FaberPolicy', id: number, client_id: number, product_id: string, account_id: number, quote_response_id: number, payment_transaction_id?: number | null, price: number, policy_number: string, prev_policy_number?: string | null, start_date: string, end_date: string, coverage_amount?: number | null, term_name?: string | null, fulfillment_time?: string | null, cancellation_received?: string | null, cancellation_date?: string | null, cancellation_reason?: string | null, cancellation_source?: string | null, admin_system: string, policy_status: FaberPolicyStatus, isImported: boolean, canFileClaim: boolean, creation_time?: string | null, neverCovered: boolean, showCancel: boolean, school: { __typename?: 'School', id: number, school_name: string }, insured: { __typename?: 'FaberInsured', id: number, client_id: number, external_insured_id: number, external_insured_cd: string, policy_id: number, school_id: number, first_name: string, last_name: string, email: string, phone: string, dob: any, years_in_school: number, address1: string, address2: string, address_city: string, address_state: string, address_zip: string, address_country: string, insured_status: string, creation_time: any, last_updated_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string }, lastPaymentFailed?: { __typename?: 'FaberPaymentTransaction', id: number, external_transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: FaberPaymentTransactionPaymentStatus, paymentMethod: { __typename?: 'FaberPaymentMethod', id: number, first_name: string, last_name: string, address1: string, address2: string, address_city: string, address_state: string, address_zip: string, address_country: string, payment_method_brand: string, exp_month: string, exp_year: string, payment_method_status: FaberPaymentMethodStatus, last4: string }, policy?: { __typename?: 'FaberPolicy', id: number, policy_number: string } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null } | null, kaminoPolicies: Array<{ __typename?: 'KaminoPolicy', uuid: string, kamino_account_holder_uuid: string, policy_number?: string | null, confirmation_number: string, previous_policy_number?: string | null, enrollment_date?: any | null, policy_start_date: any, policy_end_date?: any | null, policy_status: KaminoPolicyStatus, payment_interval: number, is_auto_renew: boolean, created_at?: any | null, updated_at?: any | null, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, policyNumber: string, details: { __typename?: 'KaminoPolicyDetails', subscription_price: number, next_amount_due: number, coverages: { __typename?: 'KaminoPolicyCoverages', price: number, property_limit: number, deductible: number, liability_limit: number, earthquake_limit: number, scheduled_property_limit: number, bedbug_limit: number } }, lastPolicyTransaction: { __typename?: 'KaminoPolicyTransaction', uuid: string, kamino_policy_uuid: string, kamino_transaction_type: TransactionTypeEnum, transaction_initiated_datetime: any, transaction_effective_datetime: any, next_pay_date?: string | null, kamino_insureds_uuid: string, kamino_coverage_uuid: string, kamino_subscription_uuid?: string | null, kamino_payment_transaction_uuid?: string | null, created_at?: any | null, updated_at?: any | null, insured: { __typename?: 'KaminoInsureds', uuid: string, kamino_address_uuid: string, effective_date: any, is_preferred: number, is_on_campus: number, property_external_id: number, property_external_cd: string, created_at?: any | null, updated_at?: any | null, address: { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null }, primaryInsured: { __typename?: 'KaminoInsuredPerson', uuid: string, kamino_insureds_uuid: string, kamino_person_uuid: string, person_type: KaminoPersonType, core_entity_id?: number | null, created_at?: any | null, updated_at?: any | null, person: { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null } }, additionalInsureds: Array<{ __typename?: 'KaminoInsuredPerson', uuid: string, kamino_insureds_uuid: string, kamino_person_uuid: string, person_type: KaminoPersonType, core_entity_id?: number | null, created_at?: any | null, updated_at?: any | null, person: { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null } }>, school: { __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean } } }, interestedParty?: { __typename?: 'KaminoInterestedParty', uuid: string, name: string, email: string, phone?: string | null, phone_country_id?: string | null, type: InterestedPartyTypeEnum, effective_date?: string | null, expiration_date?: string | null, address?: { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null }>, contactPrimaryPhone?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null, contactPrimaryEmail?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null };

export type EntityQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type EntityQuery = { __typename?: 'Query', entity: { __typename: 'Entity', id: number, uuid: string, school_id?: number | null, school: string, first_name: string, preferred_name?: string | null, middle_name?: string | null, last_name: string, dob?: string | null, requiresMfa?: boolean | null, sms_phone?: string | null, sessionImpersonation?: boolean | null, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country?: string | null, hasRenters?: boolean | null, hasKamino?: boolean | null, hasSkypad?: boolean | null, hasTuition?: boolean | null, showRentersCrossSell?: boolean | null, showTuitionCrossSell?: boolean | null, entity_email?: string | null, skypadPolicies?: Array<{ __typename?: 'SkypadPolicy', id: number, client_id?: number | null, account_id: number, policy_number: string, prev_policy_number?: string | null, subscription_id?: string | null, price: number, property_coverage: number, liability_coverage: number, earthquake_coverage: number, hurricane_coverage?: number | null, hurricane_deductible: number, deductible: number, medical_payment_to_others: number, payment_interval: number, adv_payment_interval: number, total_payments: number, end_month_balance: number, edition_schedule?: string | null, payment_plan?: string | null, payment_type?: SkypadPolicyPaymentType | null, enrollment_date?: any | null, cancellation_date?: any | null, cancellation_last_active_date?: any | null, cancellation_reason?: string | null, cancellation_source?: string | null, coverage_start_date: any, coverage_end_date?: any | null, policy_end_date?: any | null, draft_effective_date?: any | null, next_pay_date?: any | null, fulfillment_datetime?: string | null, policy_status: SkypadPolicyStatus, creation_time: any, last_update_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, isImported: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, preferred: boolean, failedPaymentTransactions?: Array<{ __typename?: 'SkypadPaymentTransaction', id: number, transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: SkypadPaymentTransactionPaymentStatus, paymentMethod?: { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> } | null, policy?: { __typename?: 'SkypadPolicy', id: number, policy_number: string } | null }> | null, insured: { __typename?: 'SkypadInsured', id: number, policy_id: number, external_id: string, external_cd: string, insured_type: SkypadPrimaryInsuredEnum, first_name: string, last_name: string, email: string, phone?: string | null, dob?: string | null, property_owner: string, property_name: string, property_external_id?: string | null, property_external_cd?: string | null, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string, allowEarthquake: boolean, isOnCampus: boolean, school?: { __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean } | null, property?: { __typename?: 'Property', id: number, property_name?: string | null, external_id?: string | null, school_id?: number | null, address1?: string | null, address2: string, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country: string, property_status: string } | null }, roommates?: Array<{ __typename?: 'SkypadRoommateInsured', id: number, policy_id: number, insured_type: SkypadRoommateInsuredEnum, first_name: string, last_name: string, email?: string | null, phone?: string | null, dob?: string | null, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string }> | null, interestedParty?: { __typename?: 'SkypadInterestedPartyInsured', id: number, policy_id: number, insured_type: SkypadInterestedPartyInsuredEnum, first_name: string, last_name?: string | null, name: string, isCompany: boolean, email?: string | null, phone?: string | null, dob?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string } | null, draft?: { __typename?: 'SkypadPolicy', id: number, client_id?: number | null, account_id: number, policy_number: string, prev_policy_number?: string | null, subscription_id?: string | null, price: number, property_coverage: number, liability_coverage: number, earthquake_coverage: number, hurricane_coverage?: number | null, hurricane_deductible: number, deductible: number, medical_payment_to_others: number, payment_interval: number, adv_payment_interval: number, total_payments: number, end_month_balance: number, edition_schedule?: string | null, payment_plan?: string | null, payment_type?: SkypadPolicyPaymentType | null, enrollment_date?: any | null, cancellation_date?: any | null, cancellation_last_active_date?: any | null, cancellation_reason?: string | null, cancellation_source?: string | null, coverage_start_date: any, coverage_end_date?: any | null, policy_end_date?: any | null, draft_effective_date?: any | null, next_pay_date?: any | null, fulfillment_datetime?: string | null, policy_status: SkypadPolicyStatus, creation_time: any, last_update_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, isImported: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, preferred: boolean } | null, lastPaymentFailed?: { __typename?: 'SkypadPaymentTransaction', id: number, transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: SkypadPaymentTransactionPaymentStatus, paymentMethod?: { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> } | null, policy?: { __typename?: 'SkypadPolicy', id: number, policy_number: string } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null }> | null, faberPolicies?: Array<{ __typename?: 'FaberPolicy', id: number, client_id: number, product_id: string, account_id: number, quote_response_id: number, payment_transaction_id?: number | null, price: number, policy_number: string, prev_policy_number?: string | null, start_date: string, end_date: string, coverage_amount?: number | null, term_name?: string | null, fulfillment_time?: string | null, cancellation_received?: string | null, cancellation_date?: string | null, cancellation_reason?: string | null, cancellation_source?: string | null, admin_system: string, policy_status: FaberPolicyStatus, isImported: boolean, canFileClaim: boolean, creation_time?: string | null, neverCovered: boolean, showCancel: boolean, school: { __typename?: 'School', id: number, school_name: string }, insured: { __typename?: 'FaberInsured', id: number, client_id: number, external_insured_id: number, external_insured_cd: string, policy_id: number, school_id: number, first_name: string, last_name: string, email: string, phone: string, dob: any, years_in_school: number, address1: string, address2: string, address_city: string, address_state: string, address_zip: string, address_country: string, insured_status: string, creation_time: any, last_updated_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string }, lastPaymentFailed?: { __typename?: 'FaberPaymentTransaction', id: number, external_transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: FaberPaymentTransactionPaymentStatus, paymentMethod: { __typename?: 'FaberPaymentMethod', id: number, first_name: string, last_name: string, address1: string, address2: string, address_city: string, address_state: string, address_zip: string, address_country: string, payment_method_brand: string, exp_month: string, exp_year: string, payment_method_status: FaberPaymentMethodStatus, last4: string }, policy?: { __typename?: 'FaberPolicy', id: number, policy_number: string } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null }> | null, lastRentersPolicy?: { __typename?: 'LastRentersPolicy', skypad?: { __typename?: 'SkypadPolicy', id: number, client_id?: number | null, account_id: number, policy_number: string, prev_policy_number?: string | null, subscription_id?: string | null, price: number, property_coverage: number, liability_coverage: number, earthquake_coverage: number, hurricane_coverage?: number | null, hurricane_deductible: number, deductible: number, medical_payment_to_others: number, payment_interval: number, adv_payment_interval: number, total_payments: number, end_month_balance: number, edition_schedule?: string | null, payment_plan?: string | null, payment_type?: SkypadPolicyPaymentType | null, enrollment_date?: any | null, cancellation_date?: any | null, cancellation_last_active_date?: any | null, cancellation_reason?: string | null, cancellation_source?: string | null, coverage_start_date: any, coverage_end_date?: any | null, policy_end_date?: any | null, draft_effective_date?: any | null, next_pay_date?: any | null, fulfillment_datetime?: string | null, policy_status: SkypadPolicyStatus, creation_time: any, last_update_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, isImported: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, preferred: boolean, failedPaymentTransactions?: Array<{ __typename?: 'SkypadPaymentTransaction', id: number, transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: SkypadPaymentTransactionPaymentStatus, paymentMethod?: { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> } | null, policy?: { __typename?: 'SkypadPolicy', id: number, policy_number: string } | null }> | null, insured: { __typename?: 'SkypadInsured', id: number, policy_id: number, external_id: string, external_cd: string, insured_type: SkypadPrimaryInsuredEnum, first_name: string, last_name: string, email: string, phone?: string | null, dob?: string | null, property_owner: string, property_name: string, property_external_id?: string | null, property_external_cd?: string | null, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string, allowEarthquake: boolean, isOnCampus: boolean, school?: { __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean } | null, property?: { __typename?: 'Property', id: number, property_name?: string | null, external_id?: string | null, school_id?: number | null, address1?: string | null, address2: string, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country: string, property_status: string } | null }, roommates?: Array<{ __typename?: 'SkypadRoommateInsured', id: number, policy_id: number, insured_type: SkypadRoommateInsuredEnum, first_name: string, last_name: string, email?: string | null, phone?: string | null, dob?: string | null, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string }> | null, interestedParty?: { __typename?: 'SkypadInterestedPartyInsured', id: number, policy_id: number, insured_type: SkypadInterestedPartyInsuredEnum, first_name: string, last_name?: string | null, name: string, isCompany: boolean, email?: string | null, phone?: string | null, dob?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string } | null, draft?: { __typename?: 'SkypadPolicy', id: number, client_id?: number | null, account_id: number, policy_number: string, prev_policy_number?: string | null, subscription_id?: string | null, price: number, property_coverage: number, liability_coverage: number, earthquake_coverage: number, hurricane_coverage?: number | null, hurricane_deductible: number, deductible: number, medical_payment_to_others: number, payment_interval: number, adv_payment_interval: number, total_payments: number, end_month_balance: number, edition_schedule?: string | null, payment_plan?: string | null, payment_type?: SkypadPolicyPaymentType | null, enrollment_date?: any | null, cancellation_date?: any | null, cancellation_last_active_date?: any | null, cancellation_reason?: string | null, cancellation_source?: string | null, coverage_start_date: any, coverage_end_date?: any | null, policy_end_date?: any | null, draft_effective_date?: any | null, next_pay_date?: any | null, fulfillment_datetime?: string | null, policy_status: SkypadPolicyStatus, creation_time: any, last_update_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, isImported: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, preferred: boolean } | null, lastPaymentFailed?: { __typename?: 'SkypadPaymentTransaction', id: number, transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: SkypadPaymentTransactionPaymentStatus, paymentMethod?: { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> } | null, policy?: { __typename?: 'SkypadPolicy', id: number, policy_number: string } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null } | null, kamino?: { __typename?: 'KaminoPolicy', uuid: string, kamino_account_holder_uuid: string, policy_number?: string | null, confirmation_number: string, previous_policy_number?: string | null, enrollment_date?: any | null, policy_start_date: any, policy_end_date?: any | null, policy_status: KaminoPolicyStatus, payment_interval: number, is_auto_renew: boolean, created_at?: any | null, updated_at?: any | null, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, policyNumber: string, details: { __typename?: 'KaminoPolicyDetails', subscription_price: number, next_amount_due: number, coverages: { __typename?: 'KaminoPolicyCoverages', price: number, property_limit: number, deductible: number, liability_limit: number, earthquake_limit: number, scheduled_property_limit: number, bedbug_limit: number } }, lastPolicyTransaction: { __typename?: 'KaminoPolicyTransaction', uuid: string, kamino_policy_uuid: string, kamino_transaction_type: TransactionTypeEnum, transaction_initiated_datetime: any, transaction_effective_datetime: any, next_pay_date?: string | null, kamino_insureds_uuid: string, kamino_coverage_uuid: string, kamino_subscription_uuid?: string | null, kamino_payment_transaction_uuid?: string | null, created_at?: any | null, updated_at?: any | null, insured: { __typename?: 'KaminoInsureds', uuid: string, kamino_address_uuid: string, effective_date: any, is_preferred: number, is_on_campus: number, property_external_id: number, property_external_cd: string, created_at?: any | null, updated_at?: any | null, address: { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null }, primaryInsured: { __typename?: 'KaminoInsuredPerson', uuid: string, kamino_insureds_uuid: string, kamino_person_uuid: string, person_type: KaminoPersonType, core_entity_id?: number | null, created_at?: any | null, updated_at?: any | null, person: { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null } }, additionalInsureds: Array<{ __typename?: 'KaminoInsuredPerson', uuid: string, kamino_insureds_uuid: string, kamino_person_uuid: string, person_type: KaminoPersonType, core_entity_id?: number | null, created_at?: any | null, updated_at?: any | null, person: { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null } }>, school: { __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean } } }, interestedParty?: { __typename?: 'KaminoInterestedParty', uuid: string, name: string, email: string, phone?: string | null, phone_country_id?: string | null, type: InterestedPartyTypeEnum, effective_date?: string | null, expiration_date?: string | null, address?: { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null } | null } | null, lastTuitionPolicy?: { __typename?: 'FaberPolicy', id: number, client_id: number, product_id: string, account_id: number, quote_response_id: number, payment_transaction_id?: number | null, price: number, policy_number: string, prev_policy_number?: string | null, start_date: string, end_date: string, coverage_amount?: number | null, term_name?: string | null, fulfillment_time?: string | null, cancellation_received?: string | null, cancellation_date?: string | null, cancellation_reason?: string | null, cancellation_source?: string | null, admin_system: string, policy_status: FaberPolicyStatus, isImported: boolean, canFileClaim: boolean, creation_time?: string | null, neverCovered: boolean, showCancel: boolean, school: { __typename?: 'School', id: number, school_name: string }, insured: { __typename?: 'FaberInsured', id: number, client_id: number, external_insured_id: number, external_insured_cd: string, policy_id: number, school_id: number, first_name: string, last_name: string, email: string, phone: string, dob: any, years_in_school: number, address1: string, address2: string, address_city: string, address_state: string, address_zip: string, address_country: string, insured_status: string, creation_time: any, last_updated_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string }, lastPaymentFailed?: { __typename?: 'FaberPaymentTransaction', id: number, external_transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: FaberPaymentTransactionPaymentStatus, paymentMethod: { __typename?: 'FaberPaymentMethod', id: number, first_name: string, last_name: string, address1: string, address2: string, address_city: string, address_state: string, address_zip: string, address_country: string, payment_method_brand: string, exp_month: string, exp_year: string, payment_method_status: FaberPaymentMethodStatus, last4: string }, policy?: { __typename?: 'FaberPolicy', id: number, policy_number: string } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null } | null, kaminoPolicies: Array<{ __typename?: 'KaminoPolicy', uuid: string, kamino_account_holder_uuid: string, policy_number?: string | null, confirmation_number: string, previous_policy_number?: string | null, enrollment_date?: any | null, policy_start_date: any, policy_end_date?: any | null, policy_status: KaminoPolicyStatus, payment_interval: number, is_auto_renew: boolean, created_at?: any | null, updated_at?: any | null, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, policyNumber: string, details: { __typename?: 'KaminoPolicyDetails', subscription_price: number, next_amount_due: number, coverages: { __typename?: 'KaminoPolicyCoverages', price: number, property_limit: number, deductible: number, liability_limit: number, earthquake_limit: number, scheduled_property_limit: number, bedbug_limit: number } }, lastPolicyTransaction: { __typename?: 'KaminoPolicyTransaction', uuid: string, kamino_policy_uuid: string, kamino_transaction_type: TransactionTypeEnum, transaction_initiated_datetime: any, transaction_effective_datetime: any, next_pay_date?: string | null, kamino_insureds_uuid: string, kamino_coverage_uuid: string, kamino_subscription_uuid?: string | null, kamino_payment_transaction_uuid?: string | null, created_at?: any | null, updated_at?: any | null, insured: { __typename?: 'KaminoInsureds', uuid: string, kamino_address_uuid: string, effective_date: any, is_preferred: number, is_on_campus: number, property_external_id: number, property_external_cd: string, created_at?: any | null, updated_at?: any | null, address: { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null }, primaryInsured: { __typename?: 'KaminoInsuredPerson', uuid: string, kamino_insureds_uuid: string, kamino_person_uuid: string, person_type: KaminoPersonType, core_entity_id?: number | null, created_at?: any | null, updated_at?: any | null, person: { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null } }, additionalInsureds: Array<{ __typename?: 'KaminoInsuredPerson', uuid: string, kamino_insureds_uuid: string, kamino_person_uuid: string, person_type: KaminoPersonType, core_entity_id?: number | null, created_at?: any | null, updated_at?: any | null, person: { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null } }>, school: { __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean } } }, interestedParty?: { __typename?: 'KaminoInterestedParty', uuid: string, name: string, email: string, phone?: string | null, phone_country_id?: string | null, type: InterestedPartyTypeEnum, effective_date?: string | null, expiration_date?: string | null, address?: { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null }>, contactPrimaryPhone?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null, contactPrimaryEmail?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null } };

export type GetFaberPaymentMethodBySessionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFaberPaymentMethodBySessionQuery = { __typename?: 'Query', getFaberPaymentMethodBySession: { __typename?: 'FaberPaymentMethod', id: number, first_name: string, last_name: string, address1: string, address2: string, address_city: string, address_state: string, address_zip: string, address_country: string, payment_method_brand: string, exp_month: string, exp_year: string, payment_method_status: FaberPaymentMethodStatus, last4: string } };

export type KaminoCancellationReasonCodeFragmentFragment = { __typename?: 'KaminoCancellationReasonCode', code: string, label: string };

export type KaminoCancellationReasonCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type KaminoCancellationReasonCodesQuery = { __typename?: 'Query', kaminoCancellationReasonCodes: Array<{ __typename?: 'KaminoCancellationReasonCode', code: string, label: string }> };

export type KaminoAddressFragmentFragment = { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null };

export type KaminoInsuredsFragmentFragment = { __typename?: 'KaminoInsureds', uuid: string, kamino_address_uuid: string, effective_date: any, is_preferred: number, is_on_campus: number, property_external_id: number, property_external_cd: string, created_at?: any | null, updated_at?: any | null, address: { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null }, primaryInsured: { __typename?: 'KaminoInsuredPerson', uuid: string, kamino_insureds_uuid: string, kamino_person_uuid: string, person_type: KaminoPersonType, core_entity_id?: number | null, created_at?: any | null, updated_at?: any | null, person: { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null } }, additionalInsureds: Array<{ __typename?: 'KaminoInsuredPerson', uuid: string, kamino_insureds_uuid: string, kamino_person_uuid: string, person_type: KaminoPersonType, core_entity_id?: number | null, created_at?: any | null, updated_at?: any | null, person: { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null } }>, school: { __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean } };

export type KaminoInsuredPersonFragmentFragment = { __typename?: 'KaminoInsuredPerson', uuid: string, kamino_insureds_uuid: string, kamino_person_uuid: string, person_type: KaminoPersonType, core_entity_id?: number | null, created_at?: any | null, updated_at?: any | null, person: { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null } };

export type KaminoFnolCreateMutationVariables = Exact<{
  input: KaminoFnolCreateInput;
}>;


export type KaminoFnolCreateMutation = { __typename?: 'Mutation', kaminoFnolCreate?: { __typename?: 'MessageResponse', message: string, type: MessageResponseType } | null };

export type KaminoInterestedPartyFragmentFragment = { __typename?: 'KaminoInterestedParty', uuid: string, name: string, email: string, phone?: string | null, phone_country_id?: string | null, type: InterestedPartyTypeEnum, effective_date?: string | null, expiration_date?: string | null };

export type KaminoPolicyCoveragesFragmentFragment = { __typename?: 'KaminoPolicyCoverages', price: number, property_limit: number, deductible: number, liability_limit: number, earthquake_limit: number, scheduled_property_limit: number, bedbug_limit: number };

export type KaminoPaymentMethodFragmentFragment = { __typename?: 'KaminoPaymentMethod', uuid: string, name: string, payment_method_brand?: string | null, exp_month?: string | null, exp_year?: string | null, last_four?: string | null, payment_method_type: string, address: { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null } };

export type KaminoPaymentMethodQueryVariables = Exact<{ [key: string]: never; }>;


export type KaminoPaymentMethodQuery = { __typename?: 'Query', kaminoPaymentMethod?: { __typename?: 'KaminoPaymentMethod', uuid: string, name: string, payment_method_brand?: string | null, exp_month?: string | null, exp_year?: string | null, last_four?: string | null, payment_method_type: string, address: { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null } } | null };

export type KaminoPaymentMethodSaveMutationVariables = Exact<{
  paymentMethod: Scalars['String']['input'];
}>;


export type KaminoPaymentMethodSaveMutation = { __typename?: 'Mutation', kaminoPaymentMethodSave: boolean };

export type KaminoPersonFragmentFragment = { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null };

export type KaminoPolicyFragmentFragment = { __typename?: 'KaminoPolicy', uuid: string, kamino_account_holder_uuid: string, policy_number?: string | null, confirmation_number: string, previous_policy_number?: string | null, enrollment_date?: any | null, policy_start_date: any, policy_end_date?: any | null, policy_status: KaminoPolicyStatus, payment_interval: number, is_auto_renew: boolean, created_at?: any | null, updated_at?: any | null, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, policyNumber: string, details: { __typename?: 'KaminoPolicyDetails', subscription_price: number, next_amount_due: number, coverages: { __typename?: 'KaminoPolicyCoverages', price: number, property_limit: number, deductible: number, liability_limit: number, earthquake_limit: number, scheduled_property_limit: number, bedbug_limit: number } }, lastPolicyTransaction: { __typename?: 'KaminoPolicyTransaction', uuid: string, kamino_policy_uuid: string, kamino_transaction_type: TransactionTypeEnum, transaction_initiated_datetime: any, transaction_effective_datetime: any, next_pay_date?: string | null, kamino_insureds_uuid: string, kamino_coverage_uuid: string, kamino_subscription_uuid?: string | null, kamino_payment_transaction_uuid?: string | null, created_at?: any | null, updated_at?: any | null, insured: { __typename?: 'KaminoInsureds', uuid: string, kamino_address_uuid: string, effective_date: any, is_preferred: number, is_on_campus: number, property_external_id: number, property_external_cd: string, created_at?: any | null, updated_at?: any | null, address: { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null }, primaryInsured: { __typename?: 'KaminoInsuredPerson', uuid: string, kamino_insureds_uuid: string, kamino_person_uuid: string, person_type: KaminoPersonType, core_entity_id?: number | null, created_at?: any | null, updated_at?: any | null, person: { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null } }, additionalInsureds: Array<{ __typename?: 'KaminoInsuredPerson', uuid: string, kamino_insureds_uuid: string, kamino_person_uuid: string, person_type: KaminoPersonType, core_entity_id?: number | null, created_at?: any | null, updated_at?: any | null, person: { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null } }>, school: { __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean } } }, interestedParty?: { __typename?: 'KaminoInterestedParty', uuid: string, name: string, email: string, phone?: string | null, phone_country_id?: string | null, type: InterestedPartyTypeEnum, effective_date?: string | null, expiration_date?: string | null, address?: { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null };

export type KaminoPolicyTransactionFragmentFragment = { __typename?: 'KaminoPolicyTransaction', uuid: string, kamino_policy_uuid: string, kamino_transaction_type: TransactionTypeEnum, transaction_initiated_datetime: any, transaction_effective_datetime: any, next_pay_date?: string | null, kamino_insureds_uuid: string, kamino_coverage_uuid: string, kamino_subscription_uuid?: string | null, kamino_payment_transaction_uuid?: string | null, created_at?: any | null, updated_at?: any | null };

export type PaginationFragmentFragment = { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean };

export type PaymentRefundFragmentFragment = { __typename?: 'PaymentRefund', id: string, amount: number, refundDatetime?: any | null, refundReason?: string | null, refundStatus?: string | null };

export type PaymentTotalRefundFragmentFragment = { __typename?: 'PaymentTotalRefund', id: string, amount: number, type: string };

export type PaymentMethodFragmentFragment = { __typename?: 'PaymentMethod', id: string, name: string, status: string, type: PaymentMethodTypeEnum, brand?: string | null, expMonth?: string | null, expYear?: string | null, lastFour?: string | null };

export type PaymentPoliciesFragmentFragment = { __typename?: 'PaymentPolicies', id: string, policyNumber: string };

export type PaymentsFragmentFragment = { __typename?: 'Payments', id: string, type: string, amount: number, transactionDatetime?: any | null, transactionStatus?: PaymentTransactionStatus | null, totalRefund: { __typename?: 'PaymentTotalRefund', id: string, amount: number, type: string }, refunds: Array<{ __typename?: 'PaymentRefund', id: string, amount: number, refundDatetime?: any | null, refundReason?: string | null, refundStatus?: string | null }>, paymentMethod?: { __typename?: 'PaymentMethod', id: string, name: string, status: string, type: PaymentMethodTypeEnum, brand?: string | null, expMonth?: string | null, expYear?: string | null, lastFour?: string | null } | null, policies: Array<{ __typename?: 'PaymentPolicies', id: string, policyNumber: string }> };

export type PaymentTransactionsQueryVariables = Exact<{
  search?: InputMaybe<PaymentTransactionsSearchInput>;
}>;


export type PaymentTransactionsQuery = { __typename?: 'Query', paymentTransactions: Array<{ __typename?: 'Payments', id: string, type: string, amount: number, transactionDatetime?: any | null, transactionStatus?: PaymentTransactionStatus | null, totalRefund: { __typename?: 'PaymentTotalRefund', id: string, amount: number, type: string }, refunds: Array<{ __typename?: 'PaymentRefund', id: string, amount: number, refundDatetime?: any | null, refundReason?: string | null, refundStatus?: string | null }>, paymentMethod?: { __typename?: 'PaymentMethod', id: string, name: string, status: string, type: PaymentMethodTypeEnum, brand?: string | null, expMonth?: string | null, expYear?: string | null, lastFour?: string | null } | null, policies: Array<{ __typename?: 'PaymentPolicies', id: string, policyNumber: string }> }> };

export type CalculateRentersCancelQueryVariables = Exact<{
  input: CalculateRentersCancelInput;
}>;


export type CalculateRentersCancelQuery = { __typename?: 'Query', calculateRentersCancel?: { __typename?: 'CalculateRentersCancelResponse', monthsRefunded: number, refundAmount: number, paymentsRemaining: number, coverageEndDate: string, policyEndDate: string, flatCancel: boolean, lastActiveDate: string } | null };

export type CalculateRentersUpdateQueryVariables = Exact<{
  input: CalculateRentersUpdateInput;
}>;


export type CalculateRentersUpdateQuery = { __typename?: 'Query', calculateRentersUpdate?: { __typename?: 'CalculateRentersUpdateResponse', operation: CalculateRentersUpdateOperationEnum, previous_policy?: { __typename?: 'CalculcateRentersUpdatePreviousPolicy', coverage_end_date: string, flat_cancel: boolean, months_refunded: number, payments_remaining: number, policy_end_date: string, refund_amount: number } | null, prorated?: { __typename?: 'CalculateRentersUpdateProrated', new_price: number, original_price: number, price: number } | null, next_policy?: { __typename?: 'CalculateRentersUpdateNextPolicy', amount_due: number, coverage_start_date?: string | null, next_pay_date?: string | null } | null } | null };

export type CancelRentersMembershipMutationVariables = Exact<{
  input: CancelRentersMembershipInput;
}>;


export type CancelRentersMembershipMutation = { __typename?: 'Mutation', cancelRentersMembership: { __typename?: 'CancelRentersMembershipResponse', monthsRefunded: number, refundAmount: number, paymentsRemaining: number, coverageEndDate: string, policyEndDate: string, flatCancel: boolean, prorationRefunds: Array<string | null>, isRefunded: boolean } };

export type FileRentersClaimMutationVariables = Exact<{
  input: FileRentersClaimInput;
}>;


export type FileRentersClaimMutation = { __typename?: 'Mutation', fileRentersClaim?: { __typename?: 'MessageResponse', message: string, type: MessageResponseType } | null };

export type MoratoriumFragmentFragment = { __typename?: 'Moratorium', id: number, city: string, county: string, state?: string | null, start_date?: any | null, end_date?: any | null, message?: string | null, moratorium_type?: string | null, moratorium_status?: string | null };

export type RentersQuoteAdminFeeFragmentFragment = { __typename?: 'RentersQuoteAdminFee', name: string, statement_descriptor: string, amount: number };

export type RentersQuotePaymentFragmentFragment = { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string };

export type RentersQuotePaymentsFragmentFragment = { __typename?: 'RentersQuotePayments', first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, second_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, pause_resume_first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string } };

export type RentersQuoteSurchargeFragmentFragment = { __typename?: 'RentersQuoteSurcharge', amount: number, modal_acknowledgement: string, modal_description: string, modal_title: string, name: string, statement_descriptor: string };

export type RentersQuoteFragmentFragment = { __typename?: 'RentersQuote', price: number, subscription_price: number, billing_fee_total: number, property_price: number, property_pretax: number, property_limit: number, liability_price: number, liability_pretax: number, liability_limit: number, earthquake_price: number, earthquake_pretax: number, earthquake_limit: number, hurricane_price: number, hurricane_pretax: number, hurricane_limit: number, term: number, deductible: number, is_bill_me_later: boolean, provider: RentersQuoteProviderEnum, admin_fee: { __typename?: 'RentersQuoteAdminFee', name: string, statement_descriptor: string, amount: number }, moratorium?: { __typename?: 'Moratorium', id: number, city: string, county: string, state?: string | null, start_date?: any | null, end_date?: any | null, message?: string | null, moratorium_type?: string | null, moratorium_status?: string | null } | null, payments: { __typename?: 'RentersQuotePayments', first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, second_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, pause_resume_first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string } }, surcharges: Array<{ __typename?: 'RentersQuoteSurcharge', amount: number, modal_acknowledgement: string, modal_description: string, modal_title: string, name: string, statement_descriptor: string }> };

export type RentersUpdateQuoteQueryQueryVariables = Exact<{
  policyNumber: Scalars['String']['input'];
  input: RentersQuoteInput;
}>;


export type RentersUpdateQuoteQueryQuery = { __typename?: 'Query', rentersUpdateQuoteQuery: { __typename?: 'RentersQuote', price: number, subscription_price: number, billing_fee_total: number, property_price: number, property_pretax: number, property_limit: number, liability_price: number, liability_pretax: number, liability_limit: number, earthquake_price: number, earthquake_pretax: number, earthquake_limit: number, hurricane_price: number, hurricane_pretax: number, hurricane_limit: number, term: number, deductible: number, is_bill_me_later: boolean, provider: RentersQuoteProviderEnum, admin_fee: { __typename?: 'RentersQuoteAdminFee', name: string, statement_descriptor: string, amount: number }, moratorium?: { __typename?: 'Moratorium', id: number, city: string, county: string, state?: string | null, start_date?: any | null, end_date?: any | null, message?: string | null, moratorium_type?: string | null, moratorium_status?: string | null } | null, payments: { __typename?: 'RentersQuotePayments', first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, second_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, pause_resume_first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string } }, surcharges: Array<{ __typename?: 'RentersQuoteSurcharge', amount: number, modal_acknowledgement: string, modal_description: string, modal_title: string, name: string, statement_descriptor: string }> } };

export type RentersQuoteParamsFragmentFragment = { __typename?: 'RentersQuoteParams', deductible: number, earthquake_coverage: number, endorsements: string };

export type RentersStartingAtQuoteQueryVariables = Exact<{
  schoolId: Scalars['Int']['input'];
}>;


export type RentersStartingAtQuoteQuery = { __typename?: 'Query', rentersStartingAtQuote: { __typename?: 'RentersStartingAtQuoteType', quote: { __typename?: 'RentersQuote', price: number, subscription_price: number, billing_fee_total: number, property_price: number, property_pretax: number, property_limit: number, liability_price: number, liability_pretax: number, liability_limit: number, earthquake_price: number, earthquake_pretax: number, earthquake_limit: number, hurricane_price: number, hurricane_pretax: number, hurricane_limit: number, term: number, deductible: number, is_bill_me_later: boolean, provider: RentersQuoteProviderEnum, admin_fee: { __typename?: 'RentersQuoteAdminFee', name: string, statement_descriptor: string, amount: number }, moratorium?: { __typename?: 'Moratorium', id: number, city: string, county: string, state?: string | null, start_date?: any | null, end_date?: any | null, message?: string | null, moratorium_type?: string | null, moratorium_status?: string | null } | null, payments: { __typename?: 'RentersQuotePayments', first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, second_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, pause_resume_first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string } }, surcharges: Array<{ __typename?: 'RentersQuoteSurcharge', amount: number, modal_acknowledgement: string, modal_description: string, modal_title: string, name: string, statement_descriptor: string }> }, quoteParams: { __typename?: 'RentersQuoteParams', deductible: number, earthquake_coverage: number, endorsements: string } } };

export type RentersCertificateQueryVariables = Exact<{
  policyNumber: Scalars['String']['input'];
  showDraft?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RentersCertificateQuery = { __typename?: 'Query', rentersCertificate?: { __typename?: 'RentersCertificateResponse', body: string, style: string } | null };

export type RentersPolicyUpdateMutationVariables = Exact<{
  input: RentersPolicyUpdateInput;
}>;


export type RentersPolicyUpdateMutation = { __typename?: 'Mutation', rentersPolicyUpdate?: { __typename?: 'RentersPolicyUpdateResponse', uuid: string, policyNumber: string, isCancelRewrite: boolean } | null };

export type SchoolsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<SchoolSearchInput>;
  orderBy?: InputMaybe<Array<OrderByClause> | OrderByClause>;
}>;


export type SchoolsQuery = { __typename?: 'Query', schools: { __typename?: 'SchoolPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean }, data: Array<{ __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean }> } };

export type MmaLoggedQueryVariables = Exact<{ [key: string]: never; }>;


export type MmaLoggedQuery = { __typename?: 'Query', mmaLogged?:
    | { __typename: 'Entity', id: number, uuid: string, school_id?: number | null, school: string, first_name: string, preferred_name?: string | null, middle_name?: string | null, last_name: string, dob?: string | null, requiresMfa?: boolean | null, sms_phone?: string | null, sessionImpersonation?: boolean | null, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country?: string | null, hasRenters?: boolean | null, hasKamino?: boolean | null, hasSkypad?: boolean | null, hasTuition?: boolean | null, showRentersCrossSell?: boolean | null, showTuitionCrossSell?: boolean | null, entity_email?: string | null, contactPrimaryPhone?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null, contactPrimaryEmail?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null }
    | { __typename: 'User', id: number, username?: string | null, first_name: string, preferred_name?: string | null, middle_name?: string | null, last_name: string, requiresMfa?: boolean | null, sms_phone?: string | null, sessionImpersonation?: boolean | null, hasRenters?: boolean | null, hasTuition?: boolean | null, hasKamino?: boolean | null, hasKaminoPaymentMethod?: boolean | null, hasSkypadPaymentMethod?: boolean | null, hasSkypad?: boolean | null, sameAsEntity?: string | null, user_email: string, user_address1?: string | null, user_address2?: string | null, user_address_city?: string | null, user_address_state?: string | null, user_address_zip?: string | null, user_address_country?: string | null, contactPrimaryPhone?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null, contactPrimaryEmail?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null, entities: Array<{ __typename?: 'Entity', id: number, uuid: string, first_name: string, last_name: string }>, kaminoValidPolicies: Array<{ __typename?: 'KaminoPolicy', uuid: string, policyNumber: string }> }
   | null };

export type GetSkypadPaymentMethodBySessionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSkypadPaymentMethodBySessionQuery = { __typename?: 'Query', getSkypadPaymentMethodBySession?: { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> } | null };

export type StripeSetupIntentQueryVariables = Exact<{ [key: string]: never; }>;


export type StripeSetupIntentQuery = { __typename?: 'Query', stripeSetupIntent: string };

export type TuitionPolicyCancelResponseFragmentFragment = { __typename?: 'TuitionPolicyCancelResponse', refund_amount: number, refund_status: string, billing_system: string, policy_end_date: string };

export type TuitionPolicyCancelMutationVariables = Exact<{
  input: TuitionPolicyCancelInput;
}>;


export type TuitionPolicyCancelMutation = { __typename?: 'Mutation', tuitionPolicyCancel?: { __typename?: 'TuitionPolicyCancelResponse', refund_amount: number, refund_status: string, billing_system: string, policy_end_date: string } | null };

export type TuitionQuoteTermParamsFragmentFragment = { __typename?: 'TuitionQuoteTermParams', term_start: string, term_end: string, extension_date?: string | null, term_name: string, term_type: string, offer_open_date?: string | null, coverage_amount: number };

export type TuitionQuoteTermFragmentFragment = { __typename?: 'TuitionQuoteTerm', quote?: { __typename?: 'TuitionQuote', products: Array<{ __typename?: 'TuitionQuoteProduct', product_id: string, product_name: string, product_benefits_uri: string, quote: { __typename?: 'TuitionQuoteProductQuote', quote_id: string, quote_country: string, quote_region: string, coverage_amount: number, price: number, national_pricing: boolean, term_start: any, term_end: any, term_name: string, term_type: string }, offer: { __typename?: 'TuitionQuoteProductOffer', offer_id: string, offer_content?: string | null, offer_content_url?: string | null, offer_content_elements?: { __typename?: 'TuitionQuoteProductOfferElements', title?: string | null, subtitle?: string | null, body?: string | null, footer?: string | null } | null }, features?: { __typename?: 'TuitionQuoteProductFeatures', existing_medical_coverage: string, housing_expense_type: string, other_school_expense_coverage: string, other_school_expense_lol: number, student_life_assistance: string, reason_illness_coverage: string, reason_injury_coverage: string, reason_death_coverage: string, reason_mental_coverage: string, reason_death_tp_coverage: string, reason_unemployment_tp_coverage: string, reason_unforeseen_coverage: string, mental_hospitalization_requirement: string, epidemic_endorsement: string } | null }> } | null, refCodeTerm?: { __typename?: 'RefCodeTerm', id: number, uuid?: string | null, term_name: string, term_start?: any | null, term_end?: any | null, offer_open_date?: any | null, extension_date?: any | null, term_type?: TermTypesEnum | null, min_coverage: number, default_coverage: number, daysRemaining?: number | null } | null, term: { __typename?: 'TuitionQuoteTermParams', term_start: string, term_end: string, extension_date?: string | null, term_name: string, term_type: string, offer_open_date?: string | null, coverage_amount: number } };

export type TuitionStartingAtQuoteQueryVariables = Exact<{
  schoolId: Scalars['Int']['input'];
}>;


export type TuitionStartingAtQuoteQuery = { __typename?: 'Query', tuitionStartingAtQuote?: { __typename?: 'TuitionQuoteTerm', quote?: { __typename?: 'TuitionQuote', products: Array<{ __typename?: 'TuitionQuoteProduct', product_id: string, product_name: string, product_benefits_uri: string, quote: { __typename?: 'TuitionQuoteProductQuote', quote_id: string, quote_country: string, quote_region: string, coverage_amount: number, price: number, national_pricing: boolean, term_start: any, term_end: any, term_name: string, term_type: string }, offer: { __typename?: 'TuitionQuoteProductOffer', offer_id: string, offer_content?: string | null, offer_content_url?: string | null, offer_content_elements?: { __typename?: 'TuitionQuoteProductOfferElements', title?: string | null, subtitle?: string | null, body?: string | null, footer?: string | null } | null }, features?: { __typename?: 'TuitionQuoteProductFeatures', existing_medical_coverage: string, housing_expense_type: string, other_school_expense_coverage: string, other_school_expense_lol: number, student_life_assistance: string, reason_illness_coverage: string, reason_injury_coverage: string, reason_death_coverage: string, reason_mental_coverage: string, reason_death_tp_coverage: string, reason_unemployment_tp_coverage: string, reason_unforeseen_coverage: string, mental_hospitalization_requirement: string, epidemic_endorsement: string } | null }> } | null, refCodeTerm?: { __typename?: 'RefCodeTerm', id: number, uuid?: string | null, term_name: string, term_start?: any | null, term_end?: any | null, offer_open_date?: any | null, extension_date?: any | null, term_type?: TermTypesEnum | null, min_coverage: number, default_coverage: number, daysRemaining?: number | null } | null, term: { __typename?: 'TuitionQuoteTermParams', term_start: string, term_end: string, extension_date?: string | null, term_name: string, term_type: string, offer_open_date?: string | null, coverage_amount: number } } | null };

export type UpdateEntityContactInfoMutationVariables = Exact<{
  entityId: Scalars['Int']['input'];
  basicInfo: ProfileBasicInfoInput;
}>;


export type UpdateEntityContactInfoMutation = { __typename?: 'Mutation', updateEntityContactInfo?: { __typename: 'Entity', id: number, uuid: string, school_id?: number | null, school: string, first_name: string, preferred_name?: string | null, middle_name?: string | null, last_name: string, dob?: string | null, requiresMfa?: boolean | null, sms_phone?: string | null, sessionImpersonation?: boolean | null, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country?: string | null, hasRenters?: boolean | null, hasKamino?: boolean | null, hasSkypad?: boolean | null, hasTuition?: boolean | null, showRentersCrossSell?: boolean | null, showTuitionCrossSell?: boolean | null, entity_email?: string | null, skypadPolicies?: Array<{ __typename?: 'SkypadPolicy', id: number, client_id?: number | null, account_id: number, policy_number: string, prev_policy_number?: string | null, subscription_id?: string | null, price: number, property_coverage: number, liability_coverage: number, earthquake_coverage: number, hurricane_coverage?: number | null, hurricane_deductible: number, deductible: number, medical_payment_to_others: number, payment_interval: number, adv_payment_interval: number, total_payments: number, end_month_balance: number, edition_schedule?: string | null, payment_plan?: string | null, payment_type?: SkypadPolicyPaymentType | null, enrollment_date?: any | null, cancellation_date?: any | null, cancellation_last_active_date?: any | null, cancellation_reason?: string | null, cancellation_source?: string | null, coverage_start_date: any, coverage_end_date?: any | null, policy_end_date?: any | null, draft_effective_date?: any | null, next_pay_date?: any | null, fulfillment_datetime?: string | null, policy_status: SkypadPolicyStatus, creation_time: any, last_update_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, isImported: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, preferred: boolean, failedPaymentTransactions?: Array<{ __typename?: 'SkypadPaymentTransaction', id: number, transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: SkypadPaymentTransactionPaymentStatus, paymentMethod?: { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> } | null, policy?: { __typename?: 'SkypadPolicy', id: number, policy_number: string } | null }> | null, insured: { __typename?: 'SkypadInsured', id: number, policy_id: number, external_id: string, external_cd: string, insured_type: SkypadPrimaryInsuredEnum, first_name: string, last_name: string, email: string, phone?: string | null, dob?: string | null, property_owner: string, property_name: string, property_external_id?: string | null, property_external_cd?: string | null, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string, allowEarthquake: boolean, isOnCampus: boolean, school?: { __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean } | null, property?: { __typename?: 'Property', id: number, property_name?: string | null, external_id?: string | null, school_id?: number | null, address1?: string | null, address2: string, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country: string, property_status: string } | null }, roommates?: Array<{ __typename?: 'SkypadRoommateInsured', id: number, policy_id: number, insured_type: SkypadRoommateInsuredEnum, first_name: string, last_name: string, email?: string | null, phone?: string | null, dob?: string | null, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string }> | null, interestedParty?: { __typename?: 'SkypadInterestedPartyInsured', id: number, policy_id: number, insured_type: SkypadInterestedPartyInsuredEnum, first_name: string, last_name?: string | null, name: string, isCompany: boolean, email?: string | null, phone?: string | null, dob?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string } | null, draft?: { __typename?: 'SkypadPolicy', id: number, client_id?: number | null, account_id: number, policy_number: string, prev_policy_number?: string | null, subscription_id?: string | null, price: number, property_coverage: number, liability_coverage: number, earthquake_coverage: number, hurricane_coverage?: number | null, hurricane_deductible: number, deductible: number, medical_payment_to_others: number, payment_interval: number, adv_payment_interval: number, total_payments: number, end_month_balance: number, edition_schedule?: string | null, payment_plan?: string | null, payment_type?: SkypadPolicyPaymentType | null, enrollment_date?: any | null, cancellation_date?: any | null, cancellation_last_active_date?: any | null, cancellation_reason?: string | null, cancellation_source?: string | null, coverage_start_date: any, coverage_end_date?: any | null, policy_end_date?: any | null, draft_effective_date?: any | null, next_pay_date?: any | null, fulfillment_datetime?: string | null, policy_status: SkypadPolicyStatus, creation_time: any, last_update_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, isImported: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, preferred: boolean } | null, lastPaymentFailed?: { __typename?: 'SkypadPaymentTransaction', id: number, transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: SkypadPaymentTransactionPaymentStatus, paymentMethod?: { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> } | null, policy?: { __typename?: 'SkypadPolicy', id: number, policy_number: string } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null }> | null, faberPolicies?: Array<{ __typename?: 'FaberPolicy', id: number, client_id: number, product_id: string, account_id: number, quote_response_id: number, payment_transaction_id?: number | null, price: number, policy_number: string, prev_policy_number?: string | null, start_date: string, end_date: string, coverage_amount?: number | null, term_name?: string | null, fulfillment_time?: string | null, cancellation_received?: string | null, cancellation_date?: string | null, cancellation_reason?: string | null, cancellation_source?: string | null, admin_system: string, policy_status: FaberPolicyStatus, isImported: boolean, canFileClaim: boolean, creation_time?: string | null, neverCovered: boolean, showCancel: boolean, school: { __typename?: 'School', id: number, school_name: string }, insured: { __typename?: 'FaberInsured', id: number, client_id: number, external_insured_id: number, external_insured_cd: string, policy_id: number, school_id: number, first_name: string, last_name: string, email: string, phone: string, dob: any, years_in_school: number, address1: string, address2: string, address_city: string, address_state: string, address_zip: string, address_country: string, insured_status: string, creation_time: any, last_updated_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string }, lastPaymentFailed?: { __typename?: 'FaberPaymentTransaction', id: number, external_transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: FaberPaymentTransactionPaymentStatus, paymentMethod: { __typename?: 'FaberPaymentMethod', id: number, first_name: string, last_name: string, address1: string, address2: string, address_city: string, address_state: string, address_zip: string, address_country: string, payment_method_brand: string, exp_month: string, exp_year: string, payment_method_status: FaberPaymentMethodStatus, last4: string }, policy?: { __typename?: 'FaberPolicy', id: number, policy_number: string } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null }> | null, lastRentersPolicy?: { __typename?: 'LastRentersPolicy', skypad?: { __typename?: 'SkypadPolicy', id: number, client_id?: number | null, account_id: number, policy_number: string, prev_policy_number?: string | null, subscription_id?: string | null, price: number, property_coverage: number, liability_coverage: number, earthquake_coverage: number, hurricane_coverage?: number | null, hurricane_deductible: number, deductible: number, medical_payment_to_others: number, payment_interval: number, adv_payment_interval: number, total_payments: number, end_month_balance: number, edition_schedule?: string | null, payment_plan?: string | null, payment_type?: SkypadPolicyPaymentType | null, enrollment_date?: any | null, cancellation_date?: any | null, cancellation_last_active_date?: any | null, cancellation_reason?: string | null, cancellation_source?: string | null, coverage_start_date: any, coverage_end_date?: any | null, policy_end_date?: any | null, draft_effective_date?: any | null, next_pay_date?: any | null, fulfillment_datetime?: string | null, policy_status: SkypadPolicyStatus, creation_time: any, last_update_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, isImported: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, preferred: boolean, failedPaymentTransactions?: Array<{ __typename?: 'SkypadPaymentTransaction', id: number, transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: SkypadPaymentTransactionPaymentStatus, paymentMethod?: { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> } | null, policy?: { __typename?: 'SkypadPolicy', id: number, policy_number: string } | null }> | null, insured: { __typename?: 'SkypadInsured', id: number, policy_id: number, external_id: string, external_cd: string, insured_type: SkypadPrimaryInsuredEnum, first_name: string, last_name: string, email: string, phone?: string | null, dob?: string | null, property_owner: string, property_name: string, property_external_id?: string | null, property_external_cd?: string | null, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string, allowEarthquake: boolean, isOnCampus: boolean, school?: { __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean } | null, property?: { __typename?: 'Property', id: number, property_name?: string | null, external_id?: string | null, school_id?: number | null, address1?: string | null, address2: string, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country: string, property_status: string } | null }, roommates?: Array<{ __typename?: 'SkypadRoommateInsured', id: number, policy_id: number, insured_type: SkypadRoommateInsuredEnum, first_name: string, last_name: string, email?: string | null, phone?: string | null, dob?: string | null, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string }> | null, interestedParty?: { __typename?: 'SkypadInterestedPartyInsured', id: number, policy_id: number, insured_type: SkypadInterestedPartyInsuredEnum, first_name: string, last_name?: string | null, name: string, isCompany: boolean, email?: string | null, phone?: string | null, dob?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, insured_status: string, creation_time: any, last_update_time: any, last_update_by?: number | null, last_update_reason?: string | null, record_status: string } | null, draft?: { __typename?: 'SkypadPolicy', id: number, client_id?: number | null, account_id: number, policy_number: string, prev_policy_number?: string | null, subscription_id?: string | null, price: number, property_coverage: number, liability_coverage: number, earthquake_coverage: number, hurricane_coverage?: number | null, hurricane_deductible: number, deductible: number, medical_payment_to_others: number, payment_interval: number, adv_payment_interval: number, total_payments: number, end_month_balance: number, edition_schedule?: string | null, payment_plan?: string | null, payment_type?: SkypadPolicyPaymentType | null, enrollment_date?: any | null, cancellation_date?: any | null, cancellation_last_active_date?: any | null, cancellation_reason?: string | null, cancellation_source?: string | null, coverage_start_date: any, coverage_end_date?: any | null, policy_end_date?: any | null, draft_effective_date?: any | null, next_pay_date?: any | null, fulfillment_datetime?: string | null, policy_status: SkypadPolicyStatus, creation_time: any, last_update_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, isImported: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, preferred: boolean } | null, lastPaymentFailed?: { __typename?: 'SkypadPaymentTransaction', id: number, transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: SkypadPaymentTransactionPaymentStatus, paymentMethod?: { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> } | null, policy?: { __typename?: 'SkypadPolicy', id: number, policy_number: string } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null } | null, kamino?: { __typename?: 'KaminoPolicy', uuid: string, kamino_account_holder_uuid: string, policy_number?: string | null, confirmation_number: string, previous_policy_number?: string | null, enrollment_date?: any | null, policy_start_date: any, policy_end_date?: any | null, policy_status: KaminoPolicyStatus, payment_interval: number, is_auto_renew: boolean, created_at?: any | null, updated_at?: any | null, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, policyNumber: string, details: { __typename?: 'KaminoPolicyDetails', subscription_price: number, next_amount_due: number, coverages: { __typename?: 'KaminoPolicyCoverages', price: number, property_limit: number, deductible: number, liability_limit: number, earthquake_limit: number, scheduled_property_limit: number, bedbug_limit: number } }, lastPolicyTransaction: { __typename?: 'KaminoPolicyTransaction', uuid: string, kamino_policy_uuid: string, kamino_transaction_type: TransactionTypeEnum, transaction_initiated_datetime: any, transaction_effective_datetime: any, next_pay_date?: string | null, kamino_insureds_uuid: string, kamino_coverage_uuid: string, kamino_subscription_uuid?: string | null, kamino_payment_transaction_uuid?: string | null, created_at?: any | null, updated_at?: any | null, insured: { __typename?: 'KaminoInsureds', uuid: string, kamino_address_uuid: string, effective_date: any, is_preferred: number, is_on_campus: number, property_external_id: number, property_external_cd: string, created_at?: any | null, updated_at?: any | null, address: { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null }, primaryInsured: { __typename?: 'KaminoInsuredPerson', uuid: string, kamino_insureds_uuid: string, kamino_person_uuid: string, person_type: KaminoPersonType, core_entity_id?: number | null, created_at?: any | null, updated_at?: any | null, person: { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null } }, additionalInsureds: Array<{ __typename?: 'KaminoInsuredPerson', uuid: string, kamino_insureds_uuid: string, kamino_person_uuid: string, person_type: KaminoPersonType, core_entity_id?: number | null, created_at?: any | null, updated_at?: any | null, person: { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null } }>, school: { __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean } } }, interestedParty?: { __typename?: 'KaminoInterestedParty', uuid: string, name: string, email: string, phone?: string | null, phone_country_id?: string | null, type: InterestedPartyTypeEnum, effective_date?: string | null, expiration_date?: string | null, address?: { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null } | null } | null, lastTuitionPolicy?: { __typename?: 'FaberPolicy', id: number, client_id: number, product_id: string, account_id: number, quote_response_id: number, payment_transaction_id?: number | null, price: number, policy_number: string, prev_policy_number?: string | null, start_date: string, end_date: string, coverage_amount?: number | null, term_name?: string | null, fulfillment_time?: string | null, cancellation_received?: string | null, cancellation_date?: string | null, cancellation_reason?: string | null, cancellation_source?: string | null, admin_system: string, policy_status: FaberPolicyStatus, isImported: boolean, canFileClaim: boolean, creation_time?: string | null, neverCovered: boolean, showCancel: boolean, school: { __typename?: 'School', id: number, school_name: string }, insured: { __typename?: 'FaberInsured', id: number, client_id: number, external_insured_id: number, external_insured_cd: string, policy_id: number, school_id: number, first_name: string, last_name: string, email: string, phone: string, dob: any, years_in_school: number, address1: string, address2: string, address_city: string, address_state: string, address_zip: string, address_country: string, insured_status: string, creation_time: any, last_updated_time: any, last_update_by: number, last_update_reason?: string | null, record_status: string }, lastPaymentFailed?: { __typename?: 'FaberPaymentTransaction', id: number, external_transaction_id: string, amount: number, currency?: string | null, charge_date?: any | null, payment_status: FaberPaymentTransactionPaymentStatus, paymentMethod: { __typename?: 'FaberPaymentMethod', id: number, first_name: string, last_name: string, address1: string, address2: string, address_city: string, address_state: string, address_zip: string, address_country: string, payment_method_brand: string, exp_month: string, exp_year: string, payment_method_status: FaberPaymentMethodStatus, last4: string }, policy?: { __typename?: 'FaberPolicy', id: number, policy_number: string } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null } | null, kaminoPolicies: Array<{ __typename?: 'KaminoPolicy', uuid: string, kamino_account_holder_uuid: string, policy_number?: string | null, confirmation_number: string, previous_policy_number?: string | null, enrollment_date?: any | null, policy_start_date: any, policy_end_date?: any | null, policy_status: KaminoPolicyStatus, payment_interval: number, is_auto_renew: boolean, created_at?: any | null, updated_at?: any | null, isAutoRenew: boolean, isMonthly: boolean, isModifiable: boolean, canFileClaim: boolean, neverCovered: boolean, canSuspend: boolean, policyNumber: string, details: { __typename?: 'KaminoPolicyDetails', subscription_price: number, next_amount_due: number, coverages: { __typename?: 'KaminoPolicyCoverages', price: number, property_limit: number, deductible: number, liability_limit: number, earthquake_limit: number, scheduled_property_limit: number, bedbug_limit: number } }, lastPolicyTransaction: { __typename?: 'KaminoPolicyTransaction', uuid: string, kamino_policy_uuid: string, kamino_transaction_type: TransactionTypeEnum, transaction_initiated_datetime: any, transaction_effective_datetime: any, next_pay_date?: string | null, kamino_insureds_uuid: string, kamino_coverage_uuid: string, kamino_subscription_uuid?: string | null, kamino_payment_transaction_uuid?: string | null, created_at?: any | null, updated_at?: any | null, insured: { __typename?: 'KaminoInsureds', uuid: string, kamino_address_uuid: string, effective_date: any, is_preferred: number, is_on_campus: number, property_external_id: number, property_external_cd: string, created_at?: any | null, updated_at?: any | null, address: { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null }, primaryInsured: { __typename?: 'KaminoInsuredPerson', uuid: string, kamino_insureds_uuid: string, kamino_person_uuid: string, person_type: KaminoPersonType, core_entity_id?: number | null, created_at?: any | null, updated_at?: any | null, person: { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null } }, additionalInsureds: Array<{ __typename?: 'KaminoInsuredPerson', uuid: string, kamino_insureds_uuid: string, kamino_person_uuid: string, person_type: KaminoPersonType, core_entity_id?: number | null, created_at?: any | null, updated_at?: any | null, person: { __typename?: 'KaminoPerson', uuid: string, first_name: string, last_name: string, email: string, phone: string, created_at?: any | null, updated_at?: any | null } }>, school: { __typename?: 'School', id: number, uuid: string, school_name: string, school_status: string, address1: string, address2?: string | null, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | null, website_url?: string | null, show_renters: boolean, show_tuition: boolean, hasRentersImplementationActive: boolean } } }, interestedParty?: { __typename?: 'KaminoInterestedParty', uuid: string, name: string, email: string, phone?: string | null, phone_country_id?: string | null, type: InterestedPartyTypeEnum, effective_date?: string | null, expiration_date?: string | null, address?: { __typename?: 'KaminoAddress', uuid: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, created_at?: any | null, updated_at?: any | null } | null } | null, documents?: Array<{ __typename?: 'policyDocumentsResponse', id?: number | null, document_title?: string | null, document_path?: string | null }> | null }>, contactPrimaryPhone?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null, contactPrimaryEmail?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null } | null };

export type UpdateRentersPaymentMethodMutationVariables = Exact<{
  address: InternationalAddressInput;
  creditCard: CreditCardInput;
  overdue: Scalars['Boolean']['input'];
}>;


export type UpdateRentersPaymentMethodMutation = { __typename?: 'Mutation', updateRentersPaymentMethod?: { __typename?: 'SkypadPaymentMethod', id: number, payment_method_brand?: string | null, account_number: string, exp_month: string, exp_year: string, last4?: string | null, first_name?: string | null, last_name?: string | null, address1?: string | null, address2?: string | null, address_city?: string | null, address_state?: string | null, address_zip?: string | null, address_country?: string | null, payment_method_status: string, update_pending: boolean, policies: Array<{ __typename?: 'SkypadPolicy', id: number, policy_number: string }> } | null };

export type UpdateUserContactInfoMutationVariables = Exact<{
  basicInfo: ProfileBasicInfoInput;
}>;


export type UpdateUserContactInfoMutation = { __typename?: 'Mutation', updateUserContactInfo?: { __typename: 'User', id: number, username?: string | null, first_name: string, preferred_name?: string | null, middle_name?: string | null, last_name: string, requiresMfa?: boolean | null, sms_phone?: string | null, sessionImpersonation?: boolean | null, hasRenters?: boolean | null, hasTuition?: boolean | null, hasKamino?: boolean | null, hasKaminoPaymentMethod?: boolean | null, hasSkypadPaymentMethod?: boolean | null, hasSkypad?: boolean | null, sameAsEntity?: string | null, user_email: string, user_address1?: string | null, user_address2?: string | null, user_address_city?: string | null, user_address_state?: string | null, user_address_zip?: string | null, user_address_country?: string | null, contactPrimaryPhone?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null, contactPrimaryEmail?: { __typename?: 'Contact', id: number, target_obj: string, target_id: number, type?: string | null, value?: string | null, phone_country_id?: number | null, domain: string, primary_flag: number, contact_flag: number, sms_flag: number, contact_status: string, creation_time: any, last_update_time: any } | null, entities: Array<{ __typename?: 'Entity', id: number, uuid: string, first_name: string, last_name: string }>, kaminoValidPolicies: Array<{ __typename?: 'KaminoPolicy', uuid: string, policyNumber: string }> } | null };

export const CancelRentersMembershipResponseFragmentFragmentDoc = gql`
    fragment CancelRentersMembershipResponseFragment on CancelRentersMembershipResponse {
  monthsRefunded
  refundAmount
  paymentsRemaining
  coverageEndDate
  policyEndDate
  flatCancel
  prorationRefunds
  isRefunded
}
    `;
export const CalculateRentersCancelResponseFragmentFragmentDoc = gql`
    fragment CalculateRentersCancelResponseFragment on CalculateRentersCancelResponse {
  monthsRefunded
  refundAmount
  paymentsRemaining
  coverageEndDate
  policyEndDate
  flatCancel
  lastActiveDate
}
    `;
export const CalculateRentersUpdateResponseFragmentFragmentDoc = gql`
    fragment CalculateRentersUpdateResponseFragment on CalculateRentersUpdateResponse {
  operation
  previous_policy {
    coverage_end_date
    flat_cancel
    months_refunded
    payments_remaining
    policy_end_date
    refund_amount
  }
  prorated {
    new_price
    original_price
    price
  }
  next_policy {
    amount_due
    coverage_start_date
    next_pay_date
  }
}
    `;
export const FaberQuoteResponseFragmentFragmentDoc = gql`
    fragment FaberQuoteResponseFragment on FaberQuoteResponse {
  id
  allianz_quote_id
  external_student_id
  quote_transaction_id
  session_id
  school_id
  client_id
  product_id
  offer_id
  cxid
  response_id
  region
  coverage_amount
  term_start
  term_end
  price
  study_abroad
  offer_language
  term_name
  term_type
  quote_response_status
  creation_time
  last_updated_time
  last_update_by
  last_update_reason
  record_status
}
    `;
export const MembershipFragmentFragmentDoc = gql`
    fragment MembershipFragment on Membership {
  id
  entity_id
  user_id
  orig_plan_id
  orig_sku_id
  policy_number
  prev_policy_number
  payment_method_id
  membership_group_id
  program_season
  program_term
  num_spouses
  num_dependents
  max_benefit
  insurance_type
  product_type
  deductible
  payment_interval
  adv_payment_interval
  total_payments
  payments_remaining
  fail_count
  end_month_balance
  enrollment_date
  start_date
  next_pay_date
  auto_renew
  client_id
  agent_id
  dtd_code
  coverage_start_date
  coverage_end_date
  covered_terms
  loss_payee
  state
  admin_system
  membership_source
  membership_status
  creation_time
  last_update_time
  last_update_by
  last_update_by_type
  created_by
  created_by_type
  last_update_reason
  record_status
  entity {
    id
    first_name
    last_name
  }
}
    `;
export const MessageResponseFragmentFragmentDoc = gql`
    fragment MessageResponseFragment on MessageResponse {
  message
  type
}
    `;
export const ContactFragmentFragmentDoc = gql`
    fragment ContactFragment on Contact {
  id
  target_obj
  target_id
  type
  value
  phone_country_id
  domain
  primary_flag
  contact_flag
  sms_flag
  contact_status
  creation_time
  last_update_time
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  __typename
  id
  user_email: email
  username
  first_name
  preferred_name
  middle_name
  last_name
  requiresMfa
  sms_phone
  user_address1: address1
  user_address2: address2
  user_address_city: address_city
  user_address_state: address_state
  user_address_zip: address_zip
  user_address_country: address_country
  sessionImpersonation
  hasRenters
  hasTuition
  hasKamino
  hasKaminoPaymentMethod
  hasSkypadPaymentMethod
  hasSkypad
  sameAsEntity
  contactPrimaryPhone {
    ...ContactFragment
  }
  contactPrimaryEmail {
    ...ContactFragment
  }
  entities {
    id
    uuid
    first_name
    last_name
  }
  kaminoValidPolicies {
    uuid
    policyNumber
  }
}
    ${ContactFragmentFragmentDoc}`;
export const EntitySessionFragmentFragmentDoc = gql`
    fragment EntitySessionFragment on Entity {
  __typename
  id
  uuid
  entity_email: email
  school_id
  school
  first_name
  preferred_name
  middle_name
  last_name
  dob
  requiresMfa
  sms_phone
  sessionImpersonation
  address1
  address2
  address_city
  address_state
  address_zip
  address_country
  hasRenters
  hasKamino
  hasSkypad
  hasTuition
  showRentersCrossSell
  showTuitionCrossSell
  contactPrimaryPhone {
    ...ContactFragment
  }
  contactPrimaryEmail {
    ...ContactFragment
  }
}
    ${ContactFragmentFragmentDoc}`;
export const MmaSessionFragmentFragmentDoc = gql`
    fragment MmaSessionFragment on MmaLoggedUser {
  __typename
  ... on User {
    ...UserFragment
  }
  ... on Entity {
    ...EntitySessionFragment
  }
}
    ${UserFragmentFragmentDoc}
${EntitySessionFragmentFragmentDoc}`;
export const PolicyCardMembershipFragmentFragmentDoc = gql`
    fragment PolicyCardMembershipFragment on PolicyCardMembership {
  policy_number
  coverage_start_date
  coverage_end_date
  membership_status
  membership_source
  insurance_type
  user_id
  entity_id
  next_pay_date
  first_name
  last_name
  mma_status_box
}
    `;
export const SkypadPolicyBaseFragmentFragmentDoc = gql`
    fragment SkypadPolicyBaseFragment on SkypadPolicy {
  id
  client_id
  account_id
  policy_number
  prev_policy_number
  subscription_id
  price
  property_coverage
  liability_coverage
  earthquake_coverage
  hurricane_coverage
  hurricane_deductible
  deductible
  medical_payment_to_others
  payment_interval
  adv_payment_interval
  total_payments
  end_month_balance
  edition_schedule
  payment_plan
  payment_type
  enrollment_date
  cancellation_date
  cancellation_last_active_date
  cancellation_reason
  cancellation_source
  coverage_start_date
  coverage_end_date
  policy_end_date
  draft_effective_date
  next_pay_date
  fulfillment_datetime
  policy_status
  creation_time
  last_update_time
  last_update_by
  last_update_reason
  record_status
  isAutoRenew
  isMonthly
  isModifiable
  isImported
  canFileClaim
  neverCovered
  canSuspend
  preferred
}
    `;
export const SkypadPaymentMethodFragmentFragmentDoc = gql`
    fragment SkypadPaymentMethodFragment on SkypadPaymentMethod {
  id
  payment_method_brand
  account_number
  exp_month
  exp_year
  last4
  first_name
  last_name
  address1
  address2
  address_city
  address_state
  address_zip
  address_country
  payment_method_status
  update_pending
  policies {
    id
    policy_number
  }
}
    `;
export const SkypadPaymentTransactionFragmentFragmentDoc = gql`
    fragment SkypadPaymentTransactionFragment on SkypadPaymentTransaction {
  id
  transaction_id
  amount
  currency
  charge_date
  payment_status
  paymentMethod {
    ...SkypadPaymentMethodFragment
  }
  policy {
    id
    policy_number
  }
}
    ${SkypadPaymentMethodFragmentFragmentDoc}`;
export const SchoolFragmentFragmentDoc = gql`
    fragment SchoolFragment on School {
  id
  uuid
  school_name
  school_status
  address1
  address2
  address_city
  address_state
  address_zip
  address_country
  logo_url
  website_url
  show_renters
  show_tuition
  hasRentersImplementationActive
}
    `;
export const PropertyFragmentFragmentDoc = gql`
    fragment PropertyFragment on Property {
  id
  property_name
  external_id
  school_id
  address1
  address2
  address_city
  address_state
  address_zip
  address_country
  property_status
}
    `;
export const SkypadInsuredFragmentFragmentDoc = gql`
    fragment SkypadInsuredFragment on SkypadInsured {
  id
  policy_id
  external_id
  external_cd
  insured_type
  first_name
  last_name
  email
  phone
  dob
  property_owner
  property_name
  property_external_id
  property_external_cd
  address1
  address2
  address_city
  address_state
  address_zip
  address_country
  insured_status
  creation_time
  last_update_time
  last_update_by
  last_update_reason
  record_status
  allowEarthquake
  isOnCampus
  school {
    ...SchoolFragment
  }
  property {
    ...PropertyFragment
  }
}
    ${SchoolFragmentFragmentDoc}
${PropertyFragmentFragmentDoc}`;
export const SkypadRoommateInsuredFragmentFragmentDoc = gql`
    fragment SkypadRoommateInsuredFragment on SkypadRoommateInsured {
  id
  policy_id
  insured_type
  first_name
  last_name
  email
  phone
  dob
  insured_status
  creation_time
  last_update_time
  last_update_by
  last_update_reason
  record_status
}
    `;
export const SkypadInterestedPartyInsuredFragmentFragmentDoc = gql`
    fragment SkypadInterestedPartyInsuredFragment on SkypadInterestedPartyInsured {
  id
  policy_id
  insured_type
  first_name
  last_name
  name
  isCompany
  email
  phone
  dob
  address1
  address2
  address_city
  address_state
  address_zip
  address_country
  insured_status
  creation_time
  last_update_time
  last_update_by
  last_update_reason
  record_status
}
    `;
export const PolicyDocumentsResponseFragmentFragmentDoc = gql`
    fragment PolicyDocumentsResponseFragment on policyDocumentsResponse {
  id
  document_title
  document_path
}
    `;
export const SkypadPolicyFragmentFragmentDoc = gql`
    fragment SkypadPolicyFragment on SkypadPolicy {
  ...SkypadPolicyBaseFragment
  failedPaymentTransactions {
    ...SkypadPaymentTransactionFragment
  }
  insured {
    ...SkypadInsuredFragment
  }
  roommates {
    ...SkypadRoommateInsuredFragment
  }
  interestedParty {
    ...SkypadInterestedPartyInsuredFragment
  }
  draft {
    ...SkypadPolicyBaseFragment
  }
  lastPaymentFailed {
    ...SkypadPaymentTransactionFragment
  }
  documents {
    ...PolicyDocumentsResponseFragment
  }
}
    ${SkypadPolicyBaseFragmentFragmentDoc}
${SkypadPaymentTransactionFragmentFragmentDoc}
${SkypadInsuredFragmentFragmentDoc}
${SkypadRoommateInsuredFragmentFragmentDoc}
${SkypadInterestedPartyInsuredFragmentFragmentDoc}
${PolicyDocumentsResponseFragmentFragmentDoc}`;
export const FaberInsuredFragmentFragmentDoc = gql`
    fragment FaberInsuredFragment on FaberInsured {
  id
  client_id
  external_insured_id
  external_insured_cd
  policy_id
  school_id
  first_name
  last_name
  email
  phone
  dob
  years_in_school
  address1
  address2
  address_city
  address_state
  address_zip
  address_country
  insured_status
  creation_time
  last_updated_time
  last_update_by
  last_update_reason
  record_status
}
    `;
export const FaberPaymentMethodFragmentFragmentDoc = gql`
    fragment FaberPaymentMethodFragment on FaberPaymentMethod {
  id
  first_name
  last_name
  address1
  address2
  address_city
  address_state
  address_zip
  address_country
  payment_method_brand
  exp_month
  exp_year
  payment_method_status
  last4: last_four
}
    `;
export const FaberPaymentTransactionFragmentFragmentDoc = gql`
    fragment FaberPaymentTransactionFragment on FaberPaymentTransaction {
  id
  external_transaction_id
  amount
  currency
  charge_date
  payment_status
  paymentMethod {
    ...FaberPaymentMethodFragment
  }
  policy {
    id
    policy_number
  }
}
    ${FaberPaymentMethodFragmentFragmentDoc}`;
export const FaberPolicyFragmentFragmentDoc = gql`
    fragment FaberPolicyFragment on FaberPolicy {
  id
  client_id
  product_id
  account_id
  quote_response_id
  school {
    id
    school_name
  }
  payment_transaction_id
  price
  policy_number
  prev_policy_number
  start_date
  end_date
  coverage_amount
  term_name
  fulfillment_time
  cancellation_received
  cancellation_date
  cancellation_reason
  cancellation_source
  admin_system
  policy_status
  isImported
  insured {
    ...FaberInsuredFragment
  }
  lastPaymentFailed {
    ...FaberPaymentTransactionFragment
  }
  canFileClaim
  creation_time
  neverCovered
  showCancel
  canFileClaim
  documents {
    ...PolicyDocumentsResponseFragment
  }
}
    ${FaberInsuredFragmentFragmentDoc}
${FaberPaymentTransactionFragmentFragmentDoc}
${PolicyDocumentsResponseFragmentFragmentDoc}`;
export const KaminoPolicyCoveragesFragmentFragmentDoc = gql`
    fragment KaminoPolicyCoveragesFragment on KaminoPolicyCoverages {
  price
  property_limit
  deductible
  liability_limit
  earthquake_limit
  scheduled_property_limit
  bedbug_limit
}
    `;
export const KaminoPolicyTransactionFragmentFragmentDoc = gql`
    fragment KaminoPolicyTransactionFragment on KaminoPolicyTransaction {
  uuid
  kamino_policy_uuid
  kamino_transaction_type
  transaction_initiated_datetime
  transaction_effective_datetime
  next_pay_date
  kamino_insureds_uuid
  kamino_coverage_uuid
  kamino_subscription_uuid
  kamino_payment_transaction_uuid
  created_at
  updated_at
}
    `;
export const KaminoAddressFragmentFragmentDoc = gql`
    fragment KaminoAddressFragment on KaminoAddress {
  uuid
  address1
  address2
  city
  state
  zipcode
  country
  created_at
  updated_at
}
    `;
export const KaminoPersonFragmentFragmentDoc = gql`
    fragment KaminoPersonFragment on KaminoPerson {
  uuid
  first_name
  last_name
  email
  phone
  created_at
  updated_at
}
    `;
export const KaminoInsuredPersonFragmentFragmentDoc = gql`
    fragment KaminoInsuredPersonFragment on KaminoInsuredPerson {
  uuid
  kamino_insureds_uuid
  kamino_person_uuid
  person_type
  core_entity_id
  created_at
  updated_at
  person {
    ...KaminoPersonFragment
  }
}
    ${KaminoPersonFragmentFragmentDoc}`;
export const KaminoInsuredsFragmentFragmentDoc = gql`
    fragment KaminoInsuredsFragment on KaminoInsureds {
  uuid
  kamino_address_uuid
  effective_date
  is_preferred
  is_on_campus
  property_external_id
  property_external_cd
  created_at
  updated_at
  address {
    ...KaminoAddressFragment
  }
  primaryInsured {
    ...KaminoInsuredPersonFragment
  }
  additionalInsureds {
    ...KaminoInsuredPersonFragment
  }
  school {
    ...SchoolFragment
  }
}
    ${KaminoAddressFragmentFragmentDoc}
${KaminoInsuredPersonFragmentFragmentDoc}
${SchoolFragmentFragmentDoc}`;
export const KaminoInterestedPartyFragmentFragmentDoc = gql`
    fragment KaminoInterestedPartyFragment on KaminoInterestedParty {
  uuid
  name
  email
  phone
  phone_country_id
  type
  effective_date
  expiration_date
}
    `;
export const KaminoPolicyFragmentFragmentDoc = gql`
    fragment KaminoPolicyFragment on KaminoPolicy {
  uuid
  kamino_account_holder_uuid
  policy_number
  confirmation_number
  previous_policy_number
  enrollment_date
  policy_start_date
  policy_end_date
  policy_status
  payment_interval
  is_auto_renew
  created_at
  updated_at
  isAutoRenew
  isMonthly
  isModifiable
  canFileClaim
  neverCovered
  canSuspend
  policyNumber
  details {
    subscription_price
    next_amount_due
    coverages {
      ...KaminoPolicyCoveragesFragment
    }
  }
  lastPolicyTransaction {
    ...KaminoPolicyTransactionFragment
    insured {
      ...KaminoInsuredsFragment
    }
  }
  interestedParty {
    ...KaminoInterestedPartyFragment
    address {
      ...KaminoAddressFragment
    }
  }
  documents {
    ...PolicyDocumentsResponseFragment
  }
}
    ${KaminoPolicyCoveragesFragmentFragmentDoc}
${KaminoPolicyTransactionFragmentFragmentDoc}
${KaminoInsuredsFragmentFragmentDoc}
${KaminoInterestedPartyFragmentFragmentDoc}
${KaminoAddressFragmentFragmentDoc}
${PolicyDocumentsResponseFragmentFragmentDoc}`;
export const LastRentersPolicyFragmentFragmentDoc = gql`
    fragment LastRentersPolicyFragment on LastRentersPolicy {
  skypad {
    ...SkypadPolicyFragment
  }
  kamino {
    ...KaminoPolicyFragment
  }
}
    ${SkypadPolicyFragmentFragmentDoc}
${KaminoPolicyFragmentFragmentDoc}`;
export const EntityFragmentFragmentDoc = gql`
    fragment EntityFragment on Entity {
  ...EntitySessionFragment
  skypadPolicies {
    ...SkypadPolicyFragment
  }
  faberPolicies {
    ...FaberPolicyFragment
  }
  lastRentersPolicy {
    ...LastRentersPolicyFragment
  }
  lastTuitionPolicy {
    ...FaberPolicyFragment
  }
  kaminoPolicies {
    ...KaminoPolicyFragment
  }
}
    ${EntitySessionFragmentFragmentDoc}
${SkypadPolicyFragmentFragmentDoc}
${FaberPolicyFragmentFragmentDoc}
${LastRentersPolicyFragmentFragmentDoc}
${KaminoPolicyFragmentFragmentDoc}`;
export const KaminoCancellationReasonCodeFragmentFragmentDoc = gql`
    fragment KaminoCancellationReasonCodeFragment on KaminoCancellationReasonCode {
  code
  label
}
    `;
export const KaminoPaymentMethodFragmentFragmentDoc = gql`
    fragment KaminoPaymentMethodFragment on KaminoPaymentMethod {
  uuid
  name
  payment_method_brand
  exp_month
  exp_year
  last_four
  payment_method_type
  address {
    ...KaminoAddressFragment
  }
}
    ${KaminoAddressFragmentFragmentDoc}`;
export const PaginationFragmentFragmentDoc = gql`
    fragment PaginationFragment on PaginatorInfo {
  total
  perPage
  currentPage
  hasMorePages
}
    `;
export const PaymentTotalRefundFragmentFragmentDoc = gql`
    fragment PaymentTotalRefundFragment on PaymentTotalRefund {
  id
  amount
  type
}
    `;
export const PaymentRefundFragmentFragmentDoc = gql`
    fragment PaymentRefundFragment on PaymentRefund {
  id
  amount
  refundDatetime
  refundReason
  refundStatus
}
    `;
export const PaymentMethodFragmentFragmentDoc = gql`
    fragment PaymentMethodFragment on PaymentMethod {
  id
  name
  status
  type
  brand
  expMonth
  expYear
  lastFour
}
    `;
export const PaymentPoliciesFragmentFragmentDoc = gql`
    fragment PaymentPoliciesFragment on PaymentPolicies {
  id
  policyNumber
}
    `;
export const PaymentsFragmentFragmentDoc = gql`
    fragment PaymentsFragment on Payments {
  id
  type
  amount
  totalRefund {
    ...PaymentTotalRefundFragment
  }
  refunds {
    ...PaymentRefundFragment
  }
  transactionDatetime
  transactionStatus
  paymentMethod {
    ...PaymentMethodFragment
  }
  policies {
    ...PaymentPoliciesFragment
  }
}
    ${PaymentTotalRefundFragmentFragmentDoc}
${PaymentRefundFragmentFragmentDoc}
${PaymentMethodFragmentFragmentDoc}
${PaymentPoliciesFragmentFragmentDoc}`;
export const RentersQuoteAdminFeeFragmentFragmentDoc = gql`
    fragment RentersQuoteAdminFeeFragment on RentersQuoteAdminFee {
  name
  statement_descriptor
  amount
}
    `;
export const MoratoriumFragmentFragmentDoc = gql`
    fragment MoratoriumFragment on Moratorium {
  id
  city
  county
  state
  start_date
  end_date
  message
  moratorium_type
  moratorium_status
}
    `;
export const RentersQuotePaymentFragmentFragmentDoc = gql`
    fragment RentersQuotePaymentFragment on RentersQuotePayment {
  display_price
  admin_fee
  billing_fee
  date
}
    `;
export const RentersQuotePaymentsFragmentFragmentDoc = gql`
    fragment RentersQuotePaymentsFragment on RentersQuotePayments {
  first_payment {
    ...RentersQuotePaymentFragment
  }
  second_payment {
    ...RentersQuotePaymentFragment
  }
  pause_resume_first_payment {
    ...RentersQuotePaymentFragment
  }
}
    ${RentersQuotePaymentFragmentFragmentDoc}`;
export const RentersQuoteSurchargeFragmentFragmentDoc = gql`
    fragment RentersQuoteSurchargeFragment on RentersQuoteSurcharge {
  amount
  modal_acknowledgement
  modal_description
  modal_title
  name
  statement_descriptor
}
    `;
export const RentersQuoteFragmentFragmentDoc = gql`
    fragment RentersQuoteFragment on RentersQuote {
  price
  subscription_price
  billing_fee_total
  property_price
  property_pretax
  property_limit
  liability_price
  liability_pretax
  liability_limit
  earthquake_price
  earthquake_pretax
  earthquake_limit
  hurricane_price
  hurricane_pretax
  hurricane_limit
  term
  deductible
  is_bill_me_later
  admin_fee {
    ...RentersQuoteAdminFeeFragment
  }
  moratorium {
    ...MoratoriumFragment
  }
  payments {
    ...RentersQuotePaymentsFragment
  }
  surcharges {
    ...RentersQuoteSurchargeFragment
  }
  provider
}
    ${RentersQuoteAdminFeeFragmentFragmentDoc}
${MoratoriumFragmentFragmentDoc}
${RentersQuotePaymentsFragmentFragmentDoc}
${RentersQuoteSurchargeFragmentFragmentDoc}`;
export const RentersQuoteParamsFragmentFragmentDoc = gql`
    fragment RentersQuoteParamsFragment on RentersQuoteParams {
  deductible
  earthquake_coverage
  endorsements
}
    `;
export const TuitionPolicyCancelResponseFragmentFragmentDoc = gql`
    fragment TuitionPolicyCancelResponseFragment on TuitionPolicyCancelResponse {
  refund_amount
  refund_status
  billing_system
  policy_end_date
}
    `;
export const TuitionQuoteFragmentFragmentDoc = gql`
    fragment TuitionQuoteFragment on TuitionQuote {
  products {
    product_id
    product_name
    product_benefits_uri
    quote {
      quote_id
      quote_country
      quote_region
      coverage_amount
      price
      national_pricing
      term_start
      term_end
      term_name
      term_type
    }
    offer {
      offer_id
      offer_content
      offer_content_url
      offer_content_elements {
        title
        subtitle
        body
        footer
      }
    }
    features {
      existing_medical_coverage
      housing_expense_type
      other_school_expense_coverage
      other_school_expense_lol
      student_life_assistance
      reason_illness_coverage
      reason_injury_coverage
      reason_death_coverage
      reason_mental_coverage
      reason_death_tp_coverage
      reason_unemployment_tp_coverage
      reason_unforeseen_coverage
      mental_hospitalization_requirement
      epidemic_endorsement
    }
  }
}
    `;
export const RefCodeTermFragmentFragmentDoc = gql`
    fragment RefCodeTermFragment on RefCodeTerm {
  id
  uuid
  term_name
  term_start
  term_end
  offer_open_date
  extension_date
  term_type
  min_coverage
  default_coverage
  daysRemaining
}
    `;
export const TuitionQuoteTermParamsFragmentFragmentDoc = gql`
    fragment TuitionQuoteTermParamsFragment on TuitionQuoteTermParams {
  term_start
  term_end
  extension_date
  term_name
  term_type
  offer_open_date
  coverage_amount
}
    `;
export const TuitionQuoteTermFragmentFragmentDoc = gql`
    fragment TuitionQuoteTermFragment on TuitionQuoteTerm {
  quote {
    ...TuitionQuoteFragment
  }
  refCodeTerm {
    ...RefCodeTermFragment
  }
  term {
    ...TuitionQuoteTermParamsFragment
  }
}
    ${TuitionQuoteFragmentFragmentDoc}
${RefCodeTermFragmentFragmentDoc}
${TuitionQuoteTermParamsFragmentFragmentDoc}`;
export const EntityDocument = gql`
    query entity($uuid: String!) {
  entity(uuid: $uuid) {
    ...EntityFragment
  }
}
    ${EntityFragmentFragmentDoc}`;
export const GetFaberPaymentMethodBySessionDocument = gql`
    query getFaberPaymentMethodBySession {
  getFaberPaymentMethodBySession {
    ...FaberPaymentMethodFragment
  }
}
    ${FaberPaymentMethodFragmentFragmentDoc}`;
export const KaminoCancellationReasonCodesDocument = gql`
    query kaminoCancellationReasonCodes {
  kaminoCancellationReasonCodes {
    ...KaminoCancellationReasonCodeFragment
  }
}
    ${KaminoCancellationReasonCodeFragmentFragmentDoc}`;
export const KaminoFnolCreateDocument = gql`
    mutation kaminoFnolCreate($input: KaminoFnolCreateInput!) {
  kaminoFnolCreate(input: $input) {
    ...MessageResponseFragment
  }
}
    ${MessageResponseFragmentFragmentDoc}`;
export const KaminoPaymentMethodDocument = gql`
    query kaminoPaymentMethod {
  kaminoPaymentMethod {
    ...KaminoPaymentMethodFragment
  }
}
    ${KaminoPaymentMethodFragmentFragmentDoc}`;
export const KaminoPaymentMethodSaveDocument = gql`
    mutation kaminoPaymentMethodSave($paymentMethod: String!) {
  kaminoPaymentMethodSave(paymentMethod: $paymentMethod)
}
    `;
export const PaymentTransactionsDocument = gql`
    query paymentTransactions($search: PaymentTransactionsSearchInput) {
  paymentTransactions(search: $search) {
    ...PaymentsFragment
  }
}
    ${PaymentsFragmentFragmentDoc}`;
export const CalculateRentersCancelDocument = gql`
    query calculateRentersCancel($input: CalculateRentersCancelInput!) {
  calculateRentersCancel(input: $input) {
    ...CalculateRentersCancelResponseFragment
  }
}
    ${CalculateRentersCancelResponseFragmentFragmentDoc}`;
export const CalculateRentersUpdateDocument = gql`
    query calculateRentersUpdate($input: CalculateRentersUpdateInput!) {
  calculateRentersUpdate(input: $input) {
    ...CalculateRentersUpdateResponseFragment
  }
}
    ${CalculateRentersUpdateResponseFragmentFragmentDoc}`;
export const CancelRentersMembershipDocument = gql`
    mutation cancelRentersMembership($input: CancelRentersMembershipInput!) {
  cancelRentersMembership(input: $input) {
    ...CancelRentersMembershipResponseFragment
  }
}
    ${CancelRentersMembershipResponseFragmentFragmentDoc}`;
export const FileRentersClaimDocument = gql`
    mutation fileRentersClaim($input: FileRentersClaimInput!) {
  fileRentersClaim(input: $input) {
    ...MessageResponseFragment
  }
}
    ${MessageResponseFragmentFragmentDoc}`;
export const RentersUpdateQuoteQueryDocument = gql`
    query rentersUpdateQuoteQuery($policyNumber: String!, $input: RentersQuoteInput!) {
  rentersUpdateQuoteQuery(policyNumber: $policyNumber, input: $input) {
    ...RentersQuoteFragment
  }
}
    ${RentersQuoteFragmentFragmentDoc}`;
export const RentersStartingAtQuoteDocument = gql`
    query rentersStartingAtQuote($schoolId: Int!) {
  rentersStartingAtQuote(schoolId: $schoolId) {
    quote {
      ...RentersQuoteFragment
    }
    quoteParams {
      ...RentersQuoteParamsFragment
    }
  }
}
    ${RentersQuoteFragmentFragmentDoc}
${RentersQuoteParamsFragmentFragmentDoc}`;
export const RentersCertificateDocument = gql`
    query rentersCertificate($policyNumber: String!, $showDraft: Boolean) {
  rentersCertificate(policyNumber: $policyNumber, showDraft: $showDraft) {
    body
    style
  }
}
    `;
export const RentersPolicyUpdateDocument = gql`
    mutation rentersPolicyUpdate($input: RentersPolicyUpdateInput!) {
  rentersPolicyUpdate(input: $input) {
    uuid
    policyNumber
    isCancelRewrite
  }
}
    `;
export const SchoolsDocument = gql`
    query schools($first: Int, $page: Int, $search: SchoolSearchInput, $orderBy: [OrderByClause!]) {
  schools(first: $first, page: $page, search: $search, orderBy: $orderBy) {
    paginatorInfo {
      ...PaginationFragment
    }
    data {
      ...SchoolFragment
    }
  }
}
    ${PaginationFragmentFragmentDoc}
${SchoolFragmentFragmentDoc}`;
export const MmaLoggedDocument = gql`
    query mmaLogged {
  mmaLogged {
    ...MmaSessionFragment
  }
}
    ${MmaSessionFragmentFragmentDoc}`;
export const GetSkypadPaymentMethodBySessionDocument = gql`
    query getSkypadPaymentMethodBySession {
  getSkypadPaymentMethodBySession {
    ...SkypadPaymentMethodFragment
  }
}
    ${SkypadPaymentMethodFragmentFragmentDoc}`;
export const StripeSetupIntentDocument = gql`
    query stripeSetupIntent {
  stripeSetupIntent
}
    `;
export const TuitionPolicyCancelDocument = gql`
    mutation tuitionPolicyCancel($input: TuitionPolicyCancelInput!) {
  tuitionPolicyCancel(input: $input) {
    ...TuitionPolicyCancelResponseFragment
  }
}
    ${TuitionPolicyCancelResponseFragmentFragmentDoc}`;
export const TuitionStartingAtQuoteDocument = gql`
    query tuitionStartingAtQuote($schoolId: Int!) {
  tuitionStartingAtQuote(schoolId: $schoolId) {
    ...TuitionQuoteTermFragment
  }
}
    ${TuitionQuoteTermFragmentFragmentDoc}`;
export const UpdateEntityContactInfoDocument = gql`
    mutation updateEntityContactInfo($entityId: Int!, $basicInfo: ProfileBasicInfoInput!) {
  updateEntityContactInfo(entityId: $entityId, basicInfo: $basicInfo) {
    ...EntityFragment
  }
}
    ${EntityFragmentFragmentDoc}`;
export const UpdateRentersPaymentMethodDocument = gql`
    mutation updateRentersPaymentMethod($address: InternationalAddressInput!, $creditCard: CreditCardInput!, $overdue: Boolean!) {
  updateRentersPaymentMethod(
    address: $address
    creditCard: $creditCard
    overdue: $overdue
  ) {
    ...SkypadPaymentMethodFragment
  }
}
    ${SkypadPaymentMethodFragmentFragmentDoc}`;
export const UpdateUserContactInfoDocument = gql`
    mutation updateUserContactInfo($basicInfo: ProfileBasicInfoInput!) {
  updateUserContactInfo(basicInfo: $basicInfo) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;